import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import {
  getCashTransactions, createCashTransaction, updateCashTransaction, deleteCashTransaction,
  getCashAccounts, createCashAccount, deleteCashAccount,
  getExpenseCategories, createExpenseCategory, deleteExpenseCategory,
  getCashDailyReport, getCashMonthlyReport,
  getSuppliers, createSupplier, updateSupplier, deleteSupplier,
  getSupplierLedger, getSupplierInvoices, getSupplierPayments,
  createSupplierInvoice, updateSupplierInvoice, deleteSupplierInvoice,
  createSupplierPayment, updateSupplierPayment, deleteSupplierPayment,
  getSuppliersSummary, getPaymentTransfers, createPaymentTransfer, updatePaymentTransfer, deletePaymentTransfer

} from '../services/api';
import Modal from '../components/Modal';
import ConfirmModal from '../components/Confirmmodal';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';
import '../styles/Pages.css';
import '../styles/Finance.css';
import { formatCurrency, formatDate } from '../utils/formatters';

const MONTH_NAMES = [
  '', 'OCAK', 'ŞUBAT', 'MART', 'NİSAN', 'MAYIS', 'HAZİRAN',
  'TEMMUZ', 'AĞUSTOS', 'EYLÜL', 'EKİM', 'KASIM', 'ARALIK'
];

const PAYMENT_METHODS = [
  { value: 'nakit', label: 'Nakit' },
  { value: 'kredi_karti', label: 'Kredi Kartı' },
  { value: 'havale', label: 'Havale/EFT' },
  { value: 'cek', label: 'Çek' },
  { value: 'pos', label: 'POS' },
  { value: 'mail_order', label: 'Mail Order' }
];

const SUPPLIER_PAYMENT_METHODS = [
  { value: 'nakit', label: 'Nakit' },
  { value: 'havale', label: 'Havale/EFT' },
  { value: 'kredi_karti', label: 'Kredi Kartı' },
  { value: 'cek', label: 'Çek' }
];

const TRANSFER_TYPES = [
  { value: 'cek', label: 'Çek' },
  { value: 'kredi_karti', label: 'Kredi Kartı' },
  { value: 'nakit', label: 'Nakit' },
  { value: 'havale', label: 'Havale/EFT' }
];

const SOURCE_TYPES = [
  { value: 'customer', label: 'Müşteriden' },
  { value: 'supplier', label: 'Tedarikçiden' },
  { value: 'account', label: 'Hesaptan/Kasadan' }
];

const TARGET_TYPES = [
  { value: 'supplier', label: 'Tedarikçiye' },
  { value: 'account', label: 'Hesaba/Kasaya' },
  { value: 'other', label: 'Diğer' }
];

function Finance() {
  const [activeMainTab, setActiveMainTab] = useState('cashflow');
  
  // ==================== KASA STATE'LERİ ====================
  const [cashSubTab, setCashSubTab] = useState('incomes');
  const [transactions, setTransactions] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cashLoading, setCashLoading] = useState(true);
  const [cashReportData, setCashReportData] = useState(null);
  
  // Ayrı hesap listeleri (YENİ)
  const [incomeAccounts, setIncomeAccounts] = useState([]);
  const [expenseAccounts, setExpenseAccounts] = useState([]);
  const [expenseCards, setExpenseCards] = useState([]);
  
  // Filtreler
  const [incomeFilters, setIncomeFilters] = useState(() => {
    const saved = localStorage.getItem('financeIncomeFilters');
    if (saved) return JSON.parse(saved);
    return { payment_method: '', year: new Date().getFullYear(), month: '', account_id: '' };
  });

  const [expenseFilters, setExpenseFilters] = useState(() => {
    const saved = localStorage.getItem('financeExpenseFilters');
    if (saved) return JSON.parse(saved);
    return { payment_method: '', category_id: '', year: new Date().getFullYear(), month: '', account_id: '', card_id: '' };
  });

  const [reportFilters, setReportFilters] = useState(() => {
    const saved = localStorage.getItem('financeReportFilters');
    if (saved) return JSON.parse(saved);
    return { year: new Date().getFullYear() };
  });

  // Modallar (YENİ - Ayrı gelir/gider modalları)
  const [isIncomeModalOpen, setIsIncomeModalOpen] = useState(false);
  const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
  const [isIncomeAccountModalOpen, setIsIncomeAccountModalOpen] = useState(false);
  const [isExpenseAccountModalOpen, setIsExpenseAccountModalOpen] = useState(false);
  const [isExpenseCardModalOpen, setIsExpenseCardModalOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [editingTransaction, setEditingTransaction] = useState(null);
  
  // GELİR FORMU - AYRI (YENİ)
  const [incomeFormData, setIncomeFormData] = useState({
    transaction_date: new Date().toISOString().split('T')[0],
    payer_name: '',
    amount: '',
    payment_method: 'nakit',
    receiver_account_id: '',
    receiver_manual: '',
    use_manual_receiver: false,
    notes: ''
  });
 
// Gelir/Gider toplu seçme
const [incomeSelectedIds, setIncomeSelectedIds] = useState([]);
const [incomeSelectMode, setIncomeSelectMode] = useState(false);
const [expenseSelectedIds, setExpenseSelectedIds] = useState([]);
const [expenseSelectMode, setExpenseSelectMode] = useState(false);

  // ==================== KART GİDERLERİ STATE'LERİ ====================
const [cardExpenses, setCardExpenses] = useState([]);
const [cardExpPage, setCardExpPage] = useState(1);
const [cardExpTotal, setCardExpTotal] = useState(0);
const [cardExpPages, setCardExpPages] = useState(1);
const [cardExpGrandTotal, setCardExpGrandTotal] = useState(0);
const [isCardExpenseModalOpen, setIsCardExpenseModalOpen] = useState(false);
const [editingCardExpense, setEditingCardExpense] = useState(null);
const [cardExpSelectedIds, setCardExpSelectedIds] = useState([]);
const [cardExpSelectMode, setCardExpSelectMode] = useState(false);

const [cardExpPageSize, setCardExpPageSize] = useState(() => {
  const saved = localStorage.getItem('financeCardExpPageSize');
  return saved ? Number(saved) : 50;
});

const [cardExpFilters, setCardExpFilters] = useState(() => {
  const saved = localStorage.getItem('financeCardExpFilters');
  if (saved) return JSON.parse(saved);
  return { year: new Date().getFullYear(), month: '', card_id: '' };
});

const [cardExpSearch, setCardExpSearch] = useState(() => {
  return localStorage.getItem('financeCardExpSearch') || '';
});

const [cardExpFormData, setCardExpFormData] = useState({
  transaction_date: new Date().toISOString().split('T')[0],
  card_id: '',
  payer_receiver: '',
  amount: '',
  is_installment: false,
  installment_count: '',
  notes: ''
});

  // ==================== CİRO/TRANSFER STATE'LERİ ====================
const [transfers, setTransfers] = useState([]);
const [transferPage, setTransferPage] = useState(1);
const [transferTotal, setTransferTotal] = useState(0);
const [transferPages, setTransferPages] = useState(1);
const [transferGrandTotal, setTransferGrandTotal] = useState(0);
const [transferGrandTotalCek, setTransferGrandTotalCek] = useState(0);
const [transferGrandTotalKredi, setTransferGrandTotalKredi] = useState(0);
const [transferGrandTotalNakit, setTransferGrandTotalNakit] = useState(0);
const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
const [editingTransfer, setEditingTransfer] = useState(null);
// Transfer toplu seçme
const [transferSelectedIds, setTransferSelectedIds] = useState([]);
const [transferSelectMode, setTransferSelectMode] = useState(false);

const [transferFilters, setTransferFilters] = useState(() => {
  const saved = localStorage.getItem('financeTransferFilters');
  if (saved) return JSON.parse(saved);
  return { transfer_type: '', year: new Date().getFullYear(), month: '' };
});

const [transferFormData, setTransferFormData] = useState({
  transfer_date: new Date().toISOString().split('T')[0],
  transfer_type: 'cek',
  amount: '',
  source_type: 'customer',
  source_name: '',
  source_supplier_id: '',
  source_account_id: '',
  target_type: 'supplier',
  target_name: '',
  target_supplier_id: '',
  target_account_id: '',
  check_no: '',
  check_bank: '',
  check_due_date: '',
  notes: ''
});

  // GİDER FORMU - AYRI (YENİ)
  const [expenseFormData, setExpenseFormData] = useState({
    transaction_date: new Date().toISOString().split('T')[0],
    payee_name: '',
    amount: '',
    category_id: '',
    payment_method: 'nakit',
    payer_account_id: '',
    payer_card_id: '',
    payer_manual: '',
    use_manual_payer: false,
    notes: ''
  });
  
  // Ayar formları (YENİ)
  const [incomeAccountForm, setIncomeAccountForm] = useState({ name: '', account_type: 'kasa' });
  const [expenseAccountForm, setExpenseAccountForm] = useState({ name: '', account_type: 'kasa' });
  const [expenseCardForm, setExpenseCardForm] = useState({ name: '', bank_name: '' });
  const [categoryForm, setCategoryForm] = useState({ name: '' });

  // ==================== TEDARİKÇİ STATE'LERİ ====================
  const [supplierSubTab, setSupplierSubTab] = useState('list');
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [ledgerData, setLedgerData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [supplierLoading, setSupplierLoading] = useState(true);
  
  const [ledgerYear, setLedgerYear] = useState(() => {
    const saved = localStorage.getItem('financeLedgerYear');
    return saved ? parseInt(saved) : new Date().getFullYear();
  });
  
  const [summaryYear, setSummaryYear] = useState(() => {
    const saved = localStorage.getItem('financeSummaryYear');
    return saved ? parseInt(saved) : new Date().getFullYear();
  });
  const [summaryMonth, setSummaryMonth] = useState(() => {
    return localStorage.getItem('financeSummaryMonth') || '';
  });

  const [invoicesList, setInvoicesList] = useState([]);
  const [paymentsList, setPaymentsList] = useState([]);
  
  const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editingPayment, setEditingPayment] = useState(null);
  
  const [supplierForm, setSupplierForm] = useState({
    name: '', contact_person: '', phone: '', email: '', address: '', notes: ''
  });
  
  const [invoiceForm, setInvoiceForm] = useState({
    supplier_id: '', invoice_date: new Date().toISOString().split('T')[0],
    amount: '', description: '', invoice_no: ''
  });
  
  const [paymentForm, setPaymentForm] = useState({
    supplier_id: '', payment_date: new Date().toISOString().split('T')[0],
    amount: '', payment_method: 'nakit', description: '', reference_no: ''
  });

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false, title: '', message: '', onConfirm: () => {}, loading: false
  });
  
  const [incomeSearch, setIncomeSearch] = useState('');
  const [expenseSearch, setExpenseSearch] = useState('');
  const [transferSourceSearch, setTransferSourceSearch] = useState('');
  const [transferTargetSearch, setTransferTargetSearch] = useState('');
  const [transPage, setTransPage] = useState(1);
  const [transTotal, setTransTotal] = useState(0);
  const [transPages, setTransPages] = useState(1);
  const [transGrandTotal, setTransGrandTotal] = useState(0);
  const [incomePageSize, setIncomePageSize] = useState(() => {
    const saved = localStorage.getItem('financeIncomePageSize');
    return saved ? Number(saved) : 50;
  });
  const [expensePageSize, setExpensePageSize] = useState(() => {
    const saved = localStorage.getItem('financeExpensePageSize');
    return saved ? Number(saved) : 50;
  });
  const [transferPageSize, setTransferPageSize] = useState(() => {
    const saved = localStorage.getItem('financeTransferPageSize');
    return saved ? Number(saved) : 50;
  });

  // Tedarikçi arama + sayfalama
  const [supplierSearch, setSupplierSearch] = useState('');
  const [supplierPage, setSupplierPage] = useState(1);
  const [supplierTotal, setSupplierTotal] = useState(0);
  const [supplierPages, setSupplierPages] = useState(1);
  const [supplierPageSize, setSupplierPageSize] = useState(() => {
    const saved = localStorage.getItem('financeSupplierPageSize');
    return saved ? Number(saved) : 50;
  });
  
  // Fatura sayfalama
  const [invoicePage, setInvoicePage] = useState(1);
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [invoicePages, setInvoicePages] = useState(1);
  const [invoiceGrandTotal, setInvoiceGrandTotal] = useState(0);
  const [invoicePageSize, setInvoicePageSize] = useState(() => {
    const saved = localStorage.getItem('financeInvoicePageSize');
    return saved ? Number(saved) : 50;
  });
  
  // Ödeme sayfalama
  const [paymentPage, setPaymentPage] = useState(1);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [paymentPages, setPaymentPages] = useState(1);
  const [paymentGrandTotal, setPaymentGrandTotal] = useState(0);
  const [paymentPageSize, setPaymentPageSize] = useState(() => {
    const saved = localStorage.getItem('financePaymentPageSize');
    return saved ? Number(saved) : 50;
  });
  
  // ==================== USE EFFECTS ====================
  useEffect(() => {
    if (activeMainTab === 'cashflow') {
      fetchCashData();
    } else if (activeMainTab === 'suppliers') {
      fetchSuppliers();
    }
  }, [activeMainTab]);

  useEffect(() => {
    if (activeMainTab === 'cashflow') {
      if (cashSubTab === 'incomes' || cashSubTab === 'expenses') {
        fetchTransactions(1);
      } else if (cashSubTab === 'reports') {
        fetchCashReport();
      }
    }
  }, [incomeFilters, expenseFilters, reportFilters, cashSubTab, activeMainTab]);

  // Arama debounce - gelir/gider
useEffect(() => {
  const timer = setTimeout(() => {
    if (cashSubTab === 'incomes' || cashSubTab === 'expenses') {
      fetchTransactions(1);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [incomeSearch, expenseSearch]);

// Arama debounce - transfer
useEffect(() => {
  const timer = setTimeout(() => {
    if (cashSubTab === 'transfers') {
      fetchTransfers(1);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [transferSourceSearch, transferTargetSearch]);

// Arama debounce - tedarikçi
  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeMainTab === 'suppliers' && supplierSubTab === 'list') {
        fetchSuppliers(1);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [supplierSearch]);

  useEffect(() => {
    if (activeMainTab === 'suppliers' && supplierSubTab === 'ledger' && selectedSupplier) {
      fetchLedger(selectedSupplier.id, ledgerYear);
      fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, 1, 1);
    }
  }, [ledgerYear]);

  useEffect(() => {
    if (activeMainTab === 'suppliers' && supplierSubTab === 'summary') {
      fetchSummary();
    }
  }, [supplierSubTab, summaryYear, summaryMonth, activeMainTab]);

  // Kart giderleri filtre değişince
useEffect(() => {
  if (activeMainTab === 'cashflow' && cashSubTab === 'card_expenses') {
    fetchCardExpenses(1);
  }
}, [cardExpFilters, cashSubTab]);

// Kart giderleri arama debounce
useEffect(() => {
  const timer = setTimeout(() => {
    if (cashSubTab === 'card_expenses') {
      fetchCardExpenses(1);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [cardExpSearch]);

// Kart giderleri kalıcılık
useEffect(() => {
  localStorage.setItem('financeCardExpFilters', JSON.stringify(cardExpFilters));
}, [cardExpFilters]);

useEffect(() => {
  localStorage.setItem('financeCardExpSearch', cardExpSearch);
}, [cardExpSearch]);
  
  // Transfer useEffect'leri
useEffect(() => {
  if (activeMainTab === 'cashflow' && cashSubTab === 'transfers') {
    fetchTransfers();
  }
}, [transferFilters, cashSubTab, activeMainTab]);

useEffect(() => {
  localStorage.setItem('financeTransferFilters', JSON.stringify(transferFilters));
}, [transferFilters]);

  useEffect(() => { localStorage.setItem('financeIncomeFilters', JSON.stringify(incomeFilters)); }, [incomeFilters]);
  useEffect(() => { localStorage.setItem('financeExpenseFilters', JSON.stringify(expenseFilters)); }, [expenseFilters]);
  useEffect(() => { localStorage.setItem('financeReportFilters', JSON.stringify(reportFilters)); }, [reportFilters]);
  useEffect(() => { localStorage.setItem('financeLedgerYear', ledgerYear.toString()); }, [ledgerYear]);
  useEffect(() => { localStorage.setItem('financeSummaryYear', summaryYear.toString()); localStorage.setItem('financeSummaryMonth', summaryMonth); }, [summaryYear, summaryMonth]);

  // ==================== FETCH FONKSİYONLARI ====================
  const fetchCashData = async () => {
  setCashLoading(true);
  try {
    const [accountsRes, categoriesRes, suppliersRes] = await Promise.all([
      getCashAccounts(),
      getExpenseCategories(),
      getSuppliers()
    ]);
    const allAccounts = accountsRes.data || [];
    setAccounts(allAccounts);
    
    setIncomeAccounts(allAccounts.filter(a => a.account_category === 'income' || !a.account_category));
    setExpenseAccounts(allAccounts.filter(a => a.account_category === 'expense'));
    setExpenseCards(allAccounts.filter(a => a.account_category === 'card'));
    
    setCategories(categoriesRes.data || []);
    setSuppliers(suppliersRes.data.items || suppliersRes.data || []);
  } catch (error) {
    console.error('Error:', error);
    toast.error('Veri yüklenirken hata oluştu');
  } finally {
    setCashLoading(false);
  }
};

  const fetchTransactions = async (page = 1, size) => {
    try {
      const currentSize = size || (cashSubTab === 'incomes' ? incomePageSize : expensePageSize);
      const params = { page, limit: currentSize };
      if (cashSubTab === 'incomes') {
        params.transaction_type = 'income';
        if (incomeFilters.payment_method) params.payment_method = incomeFilters.payment_method;
        if (incomeFilters.year) params.year = incomeFilters.year;
        if (incomeFilters.month) params.month = MONTH_NAMES[parseInt(incomeFilters.month)];
        if (incomeSearch) params.search = incomeSearch;
        if (incomeFilters.account_id === 'manual') {
          params.account_source = 'manual';
        } else if (incomeFilters.account_id === 'all-accounts') {
          params.account_source = 'all_accounts';
        } else if (incomeFilters.account_id) {
          params.account_id = incomeFilters.account_id;
        }
      } else if (cashSubTab === 'expenses') {
        params.transaction_type = 'expense';
        if (expenseFilters.payment_method) params.payment_method = expenseFilters.payment_method;
        if (expenseFilters.category_id) params.category_id = expenseFilters.category_id;
        if (expenseFilters.year) params.year = expenseFilters.year;
        if (expenseFilters.month) params.month = MONTH_NAMES[parseInt(expenseFilters.month)];
        if (expenseSearch) params.search = expenseSearch;
        if (expenseFilters.account_id === 'manual') {
          params.account_source = 'manual';
        } else if (expenseFilters.account_id === 'all-accounts') {
          params.account_source = 'all_accounts';
        } else if (expenseFilters.account_id === 'all-cards') {
          params.account_source = 'all_cards';
        } else if (expenseFilters.account_id?.startsWith('card-')) {
          params.card_id = expenseFilters.account_id.replace('card-', '');
        } else if (expenseFilters.account_id?.startsWith('acc-')) {
          params.account_id = expenseFilters.account_id.replace('acc-', '');
        }
      }
      const response = await getCashTransactions(params);
      setTransactions(response.data.items || response.data);
      setTransTotal(response.data.total || 0);
      setTransPages(response.data.pages || 1);
      setTransPage(page);
      setTransGrandTotal(response.data.grand_total || 0);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const fetchCashReport = async () => {
    try {
      const response = await getCashMonthlyReport({ year: reportFilters.year });
      setCashReportData(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const fetchSuppliers = async (page = 1, size) => {
    setSupplierLoading(true);
    try {
      const currentSize = size || supplierPageSize;
      const params = { page, limit: currentSize };
      if (supplierSearch) params.search = supplierSearch;
      const response = await getSuppliers(params);
      setSuppliers(response.data.items || response.data || []);
      setSupplierTotal(response.data.total || 0);
      setSupplierPages(response.data.pages || 1);
      setSupplierPage(page);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Tedarikçiler yüklenemedi');
    } finally {
      setSupplierLoading(false);
    }
  };

  const fetchLedger = async (supplierId, year) => {
    try {
      const response = await getSupplierLedger(supplierId, { year: year });
      setLedgerData(response.data);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Cari hesap yüklenemedi');
    }
  };

  const fetchInvoicesAndPayments = async (supplierId, year, invPage = 1, payPage = 1) => {
    try {
      const [invoicesRes, paymentsRes] = await Promise.all([
        getSupplierInvoices(supplierId, { year, page: invPage, limit: invoicePageSize }),
        getSupplierPayments(supplierId, { year, page: payPage, limit: paymentPageSize })
      ]);
      setInvoicesList(invoicesRes.data.items || invoicesRes.data || []);
      setInvoiceTotal(invoicesRes.data.total || 0);
      setInvoicePages(invoicesRes.data.pages || 1);
      setInvoicePage(invPage);
      setInvoiceGrandTotal(invoicesRes.data.grand_total || 0);
      
      setPaymentsList(paymentsRes.data.items || paymentsRes.data || []);
      setPaymentTotal(paymentsRes.data.total || 0);
      setPaymentPages(paymentsRes.data.pages || 1);
      setPaymentPage(payPage);
      setPaymentGrandTotal(paymentsRes.data.grand_total || 0);
    } catch (error) {
      console.error('Error fetching invoices/payments:', error);
    }
  };

  const fetchSummary = async () => {
    try {
      const params = { year: summaryYear };
      if (summaryMonth) params.month = parseInt(summaryMonth);
      const response = await getSuppliersSummary(params);
      setSummaryData(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  // ==================== KART GİDERLERİ FETCH ====================
const fetchCardExpenses = async (page = 1, size) => {
  try {
    const currentSize = size || cardExpPageSize;
    const params = { page, limit: currentSize, transaction_type: 'card_expense' };
    if (cardExpFilters.year) params.year = cardExpFilters.year;
    if (cardExpFilters.month) params.month = MONTH_NAMES[parseInt(cardExpFilters.month)];
    if (cardExpFilters.card_id) params.card_id = cardExpFilters.card_id;
    if (cardExpSearch) params.search = cardExpSearch;
    
    const response = await getCashTransactions(params);
    setCardExpenses(response.data.items || []);
    setCardExpTotal(response.data.total || 0);
    setCardExpPages(response.data.pages || 1);
    setCardExpPage(page);
    setCardExpGrandTotal(response.data.grand_total || 0);
  } catch (error) {
    console.error('Error:', error);
  }
};

  // ==================== TRANSFER FETCH ====================
const fetchTransfers = async (page = 1, size) => {
  try {
    const currentSize = size || transferPageSize;
    const params = { page, limit: currentSize };
    if (transferFilters.year) params.year = transferFilters.year;
    if (transferFilters.month) params.month = MONTH_NAMES[parseInt(transferFilters.month)];
    if (transferFilters.transfer_type) params.transfer_type = transferFilters.transfer_type;
    if (transferSourceSearch) params.search_source = transferSourceSearch;
    if (transferTargetSearch) params.search_target = transferTargetSearch;
    
    const response = await getPaymentTransfers(params);
    setTransfers(response.data.items || []);
    setTransferTotal(response.data.total || 0);
    setTransferPages(response.data.pages || 1);
    setTransferPage(page);
    setTransferGrandTotal(response.data.grand_total || 0);
    setTransferGrandTotalCek(response.data.grand_total_cek || 0);
    setTransferGrandTotalKredi(response.data.grand_total_kredi || 0);
    setTransferGrandTotalNakit(response.data.grand_total_nakit || 0);
  } catch (error) {
    console.error('Error:', error);
  }
};

  // ==================== GELİR HANDLER'LARI (YENİ) ====================
  const handleOpenIncomeModal = (transaction = null) => {
    if (transaction) {
      setEditingTransaction(transaction);
      setIncomeFormData({
        transaction_date: transaction.transaction_date,
        payer_name: transaction.payer_receiver || '',
        amount: transaction.amount,
        payment_method: transaction.payment_method,
        receiver_account_id: transaction.account_id || '',
        receiver_manual: transaction.account_manual || '',
        use_manual_receiver: !transaction.account_id && !!transaction.account_manual,
        notes: transaction.notes || ''
      });
    } else {
      setEditingTransaction(null);
      setIncomeFormData({
        transaction_date: new Date().toISOString().split('T')[0],
        payer_name: '', amount: '', payment_method: 'nakit',
        receiver_account_id: '', receiver_manual: '', use_manual_receiver: false, notes: ''
      });
    }
    setIsIncomeModalOpen(true);
  };

  const handleIncomeSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    try {
      const data = {
        transaction_type: 'income',
        transaction_date: incomeFormData.transaction_date,
        payer_receiver: incomeFormData.payer_name,
        amount: parseFloat(incomeFormData.amount),
        payment_method: incomeFormData.payment_method,
        account_id: incomeFormData.use_manual_receiver ? null : (incomeFormData.receiver_account_id || null),
        account_manual: incomeFormData.use_manual_receiver ? incomeFormData.receiver_manual : null,
        notes: incomeFormData.notes,
        description: incomeFormData.payer_name
      };
      if (editingTransaction) {
        await updateCashTransaction(editingTransaction.id, data);
        toast.success('Gelir güncellendi', { id: loadingToast });
      } else {
        await createCashTransaction(data);
        toast.success('Gelir eklendi', { id: loadingToast });
      }
      setIsIncomeModalOpen(false);
      fetchTransactions();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
    }
  };

  // Gelir toplu silme
const handleBulkDeleteIncomes = () => {
  setConfirmModal({
    isOpen: true, title: 'Toplu Gelir Silme',
    message: `${incomeSelectedIds.length} gelir kaydını silmek istediğinizden emin misiniz?`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        for (const id of incomeSelectedIds) { await deleteCashTransaction(id); }
        toast.success(`${incomeSelectedIds.length} gelir silindi`);
        setIncomeSelectedIds([]); setIncomeSelectMode(false);
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchTransactions(1);
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

// ==================== KART GİDERLERİ HANDLER'LARI ====================
const handleOpenCardExpenseModal = (expense = null) => {
  if (expense) {
    setEditingCardExpense(expense);
    setCardExpFormData({
      transaction_date: expense.transaction_date,
      card_id: expense.card_id || '',
      payer_receiver: expense.payer_receiver || '',
      amount: expense.amount,
      is_installment: expense.is_installment || false,
      installment_count: expense.installment_count || '',
      notes: expense.notes || ''
    });
  } else {
    setEditingCardExpense(null);
    setCardExpFormData({
      transaction_date: new Date().toISOString().split('T')[0],
      card_id: '', payer_receiver: '', amount: '',
      is_installment: false, installment_count: '', notes: ''
    });
  }
  setIsCardExpenseModalOpen(true);
};

const handleCardExpenseSubmit = async (e) => {
  e.preventDefault();
  const loadingToast = toast.loading('Kaydediliyor...');
  try {
    const data = {
      transaction_type: 'card_expense',
      transaction_date: cardExpFormData.transaction_date,
      amount: parseFloat(cardExpFormData.amount),
      payment_method: 'kredi_karti',
      card_id: parseInt(cardExpFormData.card_id) || null,
      payer_receiver: cardExpFormData.payer_receiver,
      description: cardExpFormData.payer_receiver,
      is_installment: cardExpFormData.is_installment,
      installment_count: cardExpFormData.is_installment ? (parseInt(cardExpFormData.installment_count) || null) : null,
      notes: cardExpFormData.notes
    };
    if (editingCardExpense) {
      await updateCashTransaction(editingCardExpense.id, data);
      toast.success('Kart gideri güncellendi', { id: loadingToast });
    } else {
      await createCashTransaction(data);
      toast.success('Kart gideri eklendi', { id: loadingToast });
    }
    setIsCardExpenseModalOpen(false);
    fetchCardExpenses(cardExpPage);
  } catch (error) {
    toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
  }
};

const handleDeleteCardExpense = (expense) => {
  setConfirmModal({
    isOpen: true, title: 'Kart Gideri Silme',
    message: `Bu kart giderini silmek istediğinizden emin misiniz? (${expense.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺)`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        await deleteCashTransaction(expense.id);
        toast.success('Kart gideri silindi');
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchCardExpenses(cardExpPage);
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

const handleBulkDeleteCardExpenses = () => {
  setConfirmModal({
    isOpen: true, title: 'Toplu Kart Gideri Silme',
    message: `${cardExpSelectedIds.length} kart giderini silmek istediğinizden emin misiniz?`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        for (const id of cardExpSelectedIds) {
          await deleteCashTransaction(id);
        }
        toast.success(`${cardExpSelectedIds.length} kart gideri silindi`);
        setCardExpSelectedIds([]);
        setCardExpSelectMode(false);
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchCardExpenses(1);
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

const exportCardExpensesToExcel = () => {
  if (cardExpenses.length === 0) { toast.error('İndirilecek veri bulunamadı'); return; }
  const data = cardExpenses.map(t => ({
    'Tarih': t.transaction_date,
    'Kullanılan Kart': t.card_name || '-',
    'Ödeme Yapılan Yer': t.payer_receiver || '-',
    'Tutar (₺)': t.amount,
    'Taksit': t.is_installment ? `${t.installment_count} Taksit` : 'Tek Çekim',
    'Not': t.notes || '-'
  }));
  data.push({ 'Tarih': '', 'Kullanılan Kart': 'TOPLAM', 'Ödeme Yapılan Yer': `${cardExpenses.length} kayıt`, 'Tutar (₺)': cardExpenses.reduce((sum, t) => sum + t.amount, 0), 'Taksit': '', 'Not': '' });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Kart Giderleri');
  XLSX.writeFile(wb, `KartGiderleri_${cardExpFilters.year}_${cardExpFilters.month || 'TumYil'}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

  // ==================== TRANSFER HANDLER'LARI ====================
const handleOpenTransferModal = (transfer = null) => {
  if (transfer) {
    setEditingTransfer(transfer);
    setTransferFormData({
      transfer_date: transfer.transfer_date,
      transfer_type: transfer.transfer_type,
      amount: transfer.amount,
      source_type: transfer.source_type,
      source_name: transfer.source_name || '',
      source_supplier_id: transfer.source_supplier_id || '',
      source_account_id: transfer.source_account_id || '',
      target_type: transfer.target_type,
      target_name: transfer.target_name || '',
      target_supplier_id: transfer.target_supplier_id || '',
      target_account_id: transfer.target_account_id || '',
      check_no: transfer.check_no || '',
      check_bank: transfer.check_bank || '',
      check_due_date: transfer.check_due_date || '',
      notes: transfer.notes || ''
    });
  } else {
    setEditingTransfer(null);
    setTransferFormData({
      transfer_date: new Date().toISOString().split('T')[0],
      transfer_type: 'cek', amount: '', source_type: 'customer', source_name: '',
      source_supplier_id: '', source_account_id: '', target_type: 'supplier',
      target_name: '', target_supplier_id: '', target_account_id: '',
      check_no: '', check_bank: '', check_due_date: '', notes: ''
    });
  }
  setIsTransferModalOpen(true);
};

const handleTransferSubmit = async (e) => {
  e.preventDefault();
  const loadingToast = toast.loading('Kaydediliyor...');
  try {
    const data = {
      ...transferFormData,
      amount: parseFloat(transferFormData.amount),
      source_supplier_id: transferFormData.source_supplier_id || null,
      source_account_id: transferFormData.source_account_id || null,
      target_supplier_id: transferFormData.target_supplier_id || null,
      target_account_id: transferFormData.target_account_id || null,
      check_due_date: transferFormData.check_due_date || null
    };
    if (editingTransfer) {
      await updatePaymentTransfer(editingTransfer.id, data);
      toast.success('Transfer güncellendi', { id: loadingToast });
    } else {
      await createPaymentTransfer(data);
      toast.success('Transfer eklendi', { id: loadingToast });
    }
    setIsTransferModalOpen(false);
    fetchTransfers();
  } catch (error) {
    toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
  }
};

const handleDeleteTransfer = (transfer) => {
  setConfirmModal({
    isOpen: true, title: 'Transfer Silme',
    message: `Bu transferi silmek istediğinizden emin misiniz? (${transfer.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺
)`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        await deletePaymentTransfer(transfer.id);
        toast.success('Transfer silindi');
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchTransfers();
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

const exportTransfersToExcel = () => {
  if (transfers.length === 0) { toast.error('İndirilecek veri bulunamadı'); return; }
  const data = transfers.map(t => ({
    'Tarih': t.transfer_date,
    'Tip': TRANSFER_TYPES.find(tt => tt.value === t.transfer_type)?.label || t.transfer_type,
    'Kaynak': t.source_type === 'supplier' ? t.source_supplier_name : t.source_type === 'account' ? t.source_account_name : t.source_name,
    'Hedef': t.target_type === 'supplier' ? t.target_supplier_name : t.target_type === 'account' ? t.target_account_name : t.target_name,
    'Tutar (₺)': t.amount,
    'Çek No': t.check_no || '-',
    'Banka': t.check_bank || '-',
    'Vade': t.check_due_date || '-'
  }));
  data.push({ 'Tarih': '', 'Tip': 'TOPLAM', 'Kaynak': `${transfers.length} kayıt`, 'Hedef': '', 'Tutar (₺)': transfers.reduce((sum, t) => sum + t.amount, 0), 'Çek No': '', 'Banka': '', 'Vade': '' });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Transferler');
  XLSX.writeFile(wb, `Transferler_${transferFilters.year}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

// Transfer toplu silme
const handleBulkDeleteTransfers = () => {
  setConfirmModal({
    isOpen: true, title: 'Toplu Transfer Silme',
    message: `${transferSelectedIds.length} transferi silmek istediğinizden emin misiniz?`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        for (const id of transferSelectedIds) { await deletePaymentTransfer(id); }
        toast.success(`${transferSelectedIds.length} transfer silindi`);
        setTransferSelectedIds([]); setTransferSelectMode(false);
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchTransfers(1);
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

  // ==================== GİDER HANDLER'LARI (YENİ) ====================
  const handleOpenExpenseModal = (transaction = null) => {
    if (transaction) {
      setEditingTransaction(transaction);
      setExpenseFormData({
        transaction_date: transaction.transaction_date,
        payee_name: transaction.payer_receiver || '',
        amount: transaction.amount,
        category_id: transaction.category_id || '',
        payment_method: transaction.payment_method,
        payer_account_id: transaction.account_id || '',
        payer_card_id: transaction.card_id || '',
        payer_manual: transaction.account_manual || '',
        use_manual_payer: !transaction.account_id && !transaction.card_id && !!transaction.account_manual,
        notes: transaction.notes || ''
      });
    } else {
      setEditingTransaction(null);
      setExpenseFormData({
        transaction_date: new Date().toISOString().split('T')[0],
        payee_name: '', amount: '', category_id: '', payment_method: 'nakit',
        payer_account_id: '', payer_card_id: '', payer_manual: '', use_manual_payer: false, notes: ''
      });
    }
    setIsExpenseModalOpen(true);
  };

  const handleExpenseSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    try {
      let accountId = null, cardId = null, accountManual = null;
      if (expenseFormData.use_manual_payer) {
        accountManual = expenseFormData.payer_manual;
      } else if (expenseFormData.payment_method === 'kredi_karti' && expenseFormData.payer_card_id) {
        cardId = expenseFormData.payer_card_id;
      } else if (expenseFormData.payer_account_id) {
        accountId = expenseFormData.payer_account_id;
      }
      
      const data = {
        transaction_type: 'expense',
        transaction_date: expenseFormData.transaction_date,
        payer_receiver: expenseFormData.payee_name,
        amount: parseFloat(expenseFormData.amount),
        category_id: expenseFormData.category_id || null,
        payment_method: expenseFormData.payment_method,
        account_id: accountId,
        card_id: cardId,
        account_manual: accountManual,
        notes: expenseFormData.notes,
        description: expenseFormData.payee_name
      };
      if (editingTransaction) {
        await updateCashTransaction(editingTransaction.id, data);
        toast.success('Gider güncellendi', { id: loadingToast });
      } else {
        await createCashTransaction(data);
        toast.success('Gider eklendi', { id: loadingToast });
      }
      setIsExpenseModalOpen(false);
      fetchTransactions();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
    }
  };

  const handleDeleteTransaction = (transaction) => {
    const typeText = transaction.transaction_type === 'income' ? 'Gelir' : 'Gider';
    setConfirmModal({
      isOpen: true,
      title: `${typeText} Silme`,
      message: `Bu ${typeText.toLowerCase()} kaydını silmek istediğinizden emin misiniz?`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteCashTransaction(transaction.id);
          toast.success(`${typeText} silindi`);
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          fetchTransactions();
        } catch (error) {
          toast.error('Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  // Gider toplu silme
const handleBulkDeleteExpenses = () => {
  setConfirmModal({
    isOpen: true, title: 'Toplu Gider Silme',
    message: `${expenseSelectedIds.length} gider kaydını silmek istediğinizden emin misiniz?`,
    loading: false,
    onConfirm: async () => {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      try {
        for (const id of expenseSelectedIds) { await deleteCashTransaction(id); }
        toast.success(`${expenseSelectedIds.length} gider silindi`);
        setExpenseSelectedIds([]); setExpenseSelectMode(false);
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
        fetchTransactions(1);
      } catch (error) {
        toast.error('Silme hatası');
        setConfirmModal(prev => ({ ...prev, loading: false }));
      }
    }
  });
};

  // ==================== AYARLAR HANDLER'LARI (YENİ) ====================
  const handleAddIncomeAccount = async (e) => {
    e.preventDefault();
    try {
      await createCashAccount({ ...incomeAccountForm, account_category: 'income' });
      toast.success('Gelir hesabı eklendi');
      setIsIncomeAccountModalOpen(false);
      setIncomeAccountForm({ name: '', account_type: 'kasa' });
      fetchCashData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata');
    }
  };

  const handleAddExpenseAccount = async (e) => {
    e.preventDefault();
    try {
      await createCashAccount({ ...expenseAccountForm, account_category: 'expense' });
      toast.success('Gider hesabı eklendi');
      setIsExpenseAccountModalOpen(false);
      setExpenseAccountForm({ name: '', account_type: 'kasa' });
      fetchCashData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata');
    }
  };

  const handleAddExpenseCard = async (e) => {
    e.preventDefault();
    try {
      await createCashAccount({ 
        name: expenseCardForm.name, 
        account_type: 'kart', 
        account_category: 'card', 
        notes: expenseCardForm.bank_name 
      });
      toast.success('Kart eklendi');
      setIsExpenseCardModalOpen(false);
      setExpenseCardForm({ name: '', bank_name: '' });
      fetchCashData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata');
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();
    try {
      await createExpenseCategory(categoryForm);
      toast.success('Kategori eklendi');
      setIsCategoryModalOpen(false);
      setCategoryForm({ name: '' });
      fetchCashData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata');
    }
  };

  const handleDeleteAccountByType = (account, type) => {
    const typeText = type === 'income' ? 'Gelir hesabı' : type === 'expense' ? 'Gider hesabı' : 'Kart';
    setConfirmModal({
      isOpen: true,
      title: `${typeText} Silme`,
      message: `"${account.name}" silinecek. Emin misiniz?`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteCashAccount(account.id);
          toast.success(`${typeText} silindi`);
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          fetchCashData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  const handleDeleteCategory = (category) => {
    setConfirmModal({
      isOpen: true,
      title: 'Kategori Silme',
      message: `"${category.name}" kategorisini silmek istediğinizden emin misiniz?`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteExpenseCategory(category.id);
          toast.success('Kategori silindi');
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          fetchCashData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  // ==================== EXCEL EXPORT ====================
  const exportIncomesToExcel = () => {
  const incomeData = transactions.filter(t => t.transaction_type === 'income');
  const data = incomeData.map(t => ({
    'Tarih': t.transaction_date,
    'Ödemesi Gelen': t.payer_receiver || '-',
    'Ödeme Yöntemi': PAYMENT_METHODS.find(m => m.value === t.payment_method)?.label || t.payment_method,
    'Teslim Alan (Hesap/Kasa)': t.account_name || t.account_manual || '-',
    'Tutar (₺)': t.amount
  }));
  
  if (data.length === 0) { toast.error('İndirilecek veri bulunamadı'); return; }
  
  // Toplam satırı ekle
  data.push({
    'Tarih': '',
    'Ödemesi Gelen': 'TOPLAM',
    'Ödeme Yöntemi': `${incomeData.length} kayıt`,
    'Teslim Alan (Hesap/Kasa)': '',
    'Tutar (₺)': incomeData.reduce((sum, t) => sum + t.amount, 0)
  });
  
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Gelirler');
  XLSX.writeFile(wb, `Gelirler_${incomeFilters.year}_${incomeFilters.month || 'TumYil'}.xlsx`);
  toast.success('Excel dosyası indirildi');
  };
  
  const exportExpensesToExcel = () => {
  const expenseData = transactions.filter(t => t.transaction_type === 'expense');
  const data = expenseData.map(t => ({
    'Tarih': t.transaction_date,
    'Ödemesi Yapılan': t.payer_receiver || '-',
    'Kategori': t.category_name || '-',
    'Ödeme Yöntemi': PAYMENT_METHODS.find(m => m.value === t.payment_method)?.label || t.payment_method,
    'Ödeyen (Hesap/Kasa)': t.account_name || t.card_name || t.account_manual || '-',
    'Tutar (₺)': t.amount
  }));
  
  if (data.length === 0) { toast.error('İndirilecek veri bulunamadı'); return; }
  
  // Toplam satırı ekle
  data.push({
    'Tarih': '',
    'Ödemesi Yapılan': 'TOPLAM',
    'Kategori': `${expenseData.length} kayıt`,
    'Ödeme Yöntemi': '',
    'Ödeyen (Hesap/Kasa)': '',
    'Tutar (₺)': expenseData.reduce((sum, t) => sum + t.amount, 0)
  });
  
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Giderler');
  XLSX.writeFile(wb, `Giderler_${expenseFilters.year}_${expenseFilters.month || 'TumYil'}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

  const exportReportToExcel = () => {
  if (!cashReportData) { toast.error('Rapor verisi yok'); return; }
  const data = cashReportData.monthly.map(m => ({
    'Ay': m.month_name, 
    'Gelir (₺)': m.income, 
    'Gider (₺)': m.expense, 
    'Net (₺)': m.net
  }));
  // Toplam satırı - zaten var, değişiklik yok
  data.push({
    'Ay': 'TOPLAM',
    'Gelir (₺)': cashReportData.summary.total_income,
    'Gider (₺)': cashReportData.summary.total_expense,
    'Net (₺)': cashReportData.summary.net
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Kasa Raporu');
  XLSX.writeFile(wb, `KasaRaporu_${reportFilters.year}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

const exportSuppliersToExcel = () => {
  if (suppliers.length === 0) { toast.error('İndirilecek veri bulunamadı'); return; }
  const data = suppliers.map(s => ({
    'ID': s.id, 
    'Firma Adı': s.name, 
    'İlgili Kişi': s.contact_person || '-',
    'Telefon': s.phone || '-', 
    'Email': s.email || '-', 
    'Bakiye (₺)': s.total_debt || 0
  }));
  // Toplam satırı ekle
  data.push({
    'ID': '',
    'Firma Adı': 'TOPLAM',
    'İlgili Kişi': `${suppliers.length} tedarikçi`,
    'Telefon': '',
    'Email': '',
    'Bakiye (₺)': suppliers.reduce((sum, s) => sum + (s.total_debt || 0), 0)
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Tedarikçiler');
  XLSX.writeFile(wb, `Tedarikciler.xlsx`);
  toast.success('Excel dosyası indirildi');
};

const exportLedgerToExcel = () => {
  if (!ledgerData || !selectedSupplier) { toast.error('Cari hesap verisi yok'); return; }
  const data = ledgerData.monthly.map(m => ({
    'Ay': m.month_name, 
    'Devir (₺)': m.opening_balance, 
    'Alınan (₺)': m.total_invoices,
    'Nakit/Havale (₺)': m.payment_cash, 
    'Kart (₺)': m.payment_card, 
    'Çek (₺)': m.payment_check,
    'Toplam Ödeme (₺)': m.total_payments, 
    'Kalan (₺)': m.closing_balance
  }));
  // Toplam satırı ekle
  data.push({
    'Ay': 'TOPLAM',
    'Devir (₺)': ledgerData.opening_balance,
    'Alınan (₺)': ledgerData.total_invoices,
    'Nakit/Havale (₺)': ledgerData.monthly.reduce((sum, m) => sum + m.payment_cash, 0),
    'Kart (₺)': ledgerData.monthly.reduce((sum, m) => sum + m.payment_card, 0),
    'Çek (₺)': ledgerData.monthly.reduce((sum, m) => sum + m.payment_check, 0),
    'Toplam Ödeme (₺)': ledgerData.total_payments,
    'Kalan (₺)': ledgerData.closing_balance
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Cari Hesap');
  XLSX.writeFile(wb, `CariHesap_${selectedSupplier.name}_${ledgerYear}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

const exportSummaryToExcel = () => {
  if (!summaryData) { toast.error('Özet verisi yok'); return; }
  const data = summaryData.suppliers.map(s => ({
    'Tedarikçi': s.supplier_name, 
    'Devir (₺)': s.opening_balance,
    'Dönem Alınan (₺)': s.period_invoices, 
    'Dönem Ödenen (₺)': s.period_payments,
    'Kalan Bakiye (₺)': s.closing_balance
  }));
  // Toplam satırı - devir toplamı da ekle
  data.push({
    'Tedarikçi': `TOPLAM (${summaryData.suppliers.length} tedarikçi)`,
    'Devir (₺)': summaryData.suppliers.reduce((sum, s) => sum + s.opening_balance, 0),
    'Dönem Alınan (₺)': summaryData.summary.total_invoices,
    'Dönem Ödenen (₺)': summaryData.summary.total_payments,
    'Kalan Bakiye (₺)': summaryData.summary.total_balance
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Özet Rapor');
  XLSX.writeFile(wb, `TedarikciOzet_${summaryYear}_${summaryMonth || 'TumYil'}.xlsx`);
  toast.success('Excel dosyası indirildi');
};

  // ==================== TEDARİKÇİ HANDLER'LARI ====================
  const handleSelectSupplier = (supplier) => {
    setSelectedSupplier(supplier);
    setSupplierSubTab('ledger');
    fetchLedger(supplier.id, ledgerYear);
    fetchInvoicesAndPayments(supplier.id, ledgerYear);
  };

  const handleOpenSupplierModal = (supplier = null) => {
    if (supplier) {
      setEditingSupplier(supplier);
      setSupplierForm({
        name: supplier.name || '', contact_person: supplier.contact_person || '',
        phone: supplier.phone || '', email: supplier.email || '',
        address: supplier.address || '', notes: supplier.notes || ''
      });
    } else {
      setEditingSupplier(null);
      setSupplierForm({ name: '', contact_person: '', phone: '', email: '', address: '', notes: '' });
    }
    setIsSupplierModalOpen(true);
  };

  const handleSupplierSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    try {
      if (editingSupplier) {
        await updateSupplier(editingSupplier.id, supplierForm);
        toast.success('Tedarikçi güncellendi', { id: loadingToast });
      } else {
        await createSupplier(supplierForm);
        toast.success('Tedarikçi eklendi', { id: loadingToast });
      }
      setIsSupplierModalOpen(false);
      fetchSuppliers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
    }
  };

  const handleDeleteSupplier = (supplier) => {
    setConfirmModal({
      isOpen: true,
      title: 'Tedarikçi Silme',
      message: `"${supplier.name}" tedarikçisini silmek istediğinizden emin misiniz?`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteSupplier(supplier.id);
          toast.success('Tedarikçi silindi');
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          fetchSuppliers();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  // ==================== FATURA HANDLER'LARI ====================
  const handleOpenInvoiceModal = (invoice = null) => {
    if (invoice) {
      setEditingInvoice(invoice);
      setInvoiceForm({
        supplier_id: invoice.supplier_id, invoice_date: invoice.invoice_date,
        amount: invoice.amount, description: invoice.description || '', invoice_no: invoice.invoice_no || ''
      });
    } else {
      setEditingInvoice(null);
      setInvoiceForm({
        supplier_id: selectedSupplier?.id || '', invoice_date: new Date().toISOString().split('T')[0],
        amount: '', description: '', invoice_no: ''
      });
    }
    setIsInvoiceModalOpen(true);
  };

  const handleSubmitInvoice = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    try {
      const data = { ...invoiceForm, supplier_id: parseInt(invoiceForm.supplier_id), amount: parseFloat(invoiceForm.amount) };
      if (editingInvoice) {
        await updateSupplierInvoice(editingInvoice.id, data);
        toast.success('Fatura güncellendi', { id: loadingToast });
      } else {
        await createSupplierInvoice(data);
        toast.success('Fatura eklendi', { id: loadingToast });
      }
      setIsInvoiceModalOpen(false);
      if (selectedSupplier) {
        fetchLedger(selectedSupplier.id, ledgerYear);
        fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear);
      }
      fetchSuppliers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
    }
  };

  const handleDeleteInvoice = (invoice) => {
    setConfirmModal({
      isOpen: true, title: 'Fatura Silme',
      message: `Bu faturayı silmek istediğinizden emin misiniz? (${invoice.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺
)`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteSupplierInvoice(invoice.id);
          toast.success('Fatura silindi');
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          if (selectedSupplier) {
            fetchLedger(selectedSupplier.id, ledgerYear);
            fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear);
          }
          fetchSuppliers();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  // ==================== ÖDEME HANDLER'LARI ====================
  const handleOpenPaymentModal = (payment = null) => {
    if (payment) {
      setEditingPayment(payment);
      setPaymentForm({
        supplier_id: payment.supplier_id, payment_date: payment.payment_date, amount: payment.amount,
        payment_method: payment.payment_method, description: payment.description || '', reference_no: payment.reference_no || ''
      });
    } else {
      setEditingPayment(null);
      setPaymentForm({
        supplier_id: selectedSupplier?.id || '', payment_date: new Date().toISOString().split('T')[0],
        amount: '', payment_method: 'nakit', description: '', reference_no: ''
      });
    }
    setIsPaymentModalOpen(true);
  };

  const handleSubmitPayment = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Kaydediliyor...');
    try {
      const data = { ...paymentForm, supplier_id: parseInt(paymentForm.supplier_id), amount: parseFloat(paymentForm.amount) };
      if (editingPayment) {
        await updateSupplierPayment(editingPayment.id, data);
        toast.success('Ödeme güncellendi', { id: loadingToast });
      } else {
        await createSupplierPayment(data);
        toast.success('Ödeme eklendi', { id: loadingToast });
      }
      setIsPaymentModalOpen(false);
      if (selectedSupplier) {
        fetchLedger(selectedSupplier.id, ledgerYear);
        fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear);
      }
      fetchSuppliers();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Hata oluştu', { id: loadingToast });
    }
  };

  const handleDeletePayment = (payment) => {
    setConfirmModal({
      isOpen: true, title: 'Ödeme Silme',
      message: `Bu ödemeyi silmek istediğinizden emin misiniz? (${payment.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺
)`,
      loading: false,
      onConfirm: async () => {
        setConfirmModal(prev => ({ ...prev, loading: true }));
        try {
          await deleteSupplierPayment(payment.id);
          toast.success('Ödeme silindi');
          setConfirmModal(prev => ({ ...prev, isOpen: false }));
          if (selectedSupplier) {
            fetchLedger(selectedSupplier.id, ledgerYear);
            fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear);
          }
          fetchSuppliers();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Silme hatası');
          setConfirmModal(prev => ({ ...prev, loading: false }));
        }
      }
    });
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      
      <div className="page-content">
        <h1 className="page-title">Finans Yönetimi</h1>
        
        {/* Ana Tab Navigation */}
        <div className="finance-main-tabs">
          <button className={activeMainTab === 'cashflow' ? 'active' : ''} onClick={() => setActiveMainTab('cashflow')}>
             Kasa İşlemleri
          </button>
          <button className={activeMainTab === 'suppliers' ? 'active' : ''} onClick={() => setActiveMainTab('suppliers')}>
             Tedarikçi Borç Takibi
          </button>
        </div>

        {/* ==================== KASA İŞLEMLERİ TAB ==================== */}
        {activeMainTab === 'cashflow' && (
          <>
            <div className="finance-sub-tabs">
             <button className={cashSubTab === 'incomes' ? 'active' : ''} onClick={() => setCashSubTab('incomes')}>📈 Gelirler</button>
             <button className={cashSubTab === 'expenses' ? 'active' : ''} onClick={() => setCashSubTab('expenses')}>📉 Giderler</button>
             <button className={cashSubTab === 'card_expenses' ? 'active' : ''} onClick={() => setCashSubTab('card_expenses')}>💳 Kart Giderleri</button>
             <button className={cashSubTab === 'transfers' ? 'active' : ''} onClick={() => setCashSubTab('transfers')}>🔄 Ciro/Transfer</button>
             <button className={cashSubTab === 'reports' ? 'active' : ''} onClick={() => setCashSubTab('reports')}>📊 Raporlar</button>
             <button className={cashSubTab === 'settings' ? 'active' : ''} onClick={() => setCashSubTab('settings')}>⚙️ Ayarlar</button>
             </div>

            {/* ===== GELİRLER ===== */}
            {cashSubTab === 'incomes' && (
              <>
                <div className="page-header">
                  <h2>Gelirler (Tahsilatlar)</h2>
                  <div className="header-actions">
                    <button className="btn-excel" onClick={exportIncomesToExcel}>📥 Excel</button>
                    {incomeSelectMode ? (
                      <>
                        {incomeSelectedIds.length > 0 && (
                          <button onClick={handleBulkDeleteIncomes}
                            style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                          Seçilenleri Sil ({incomeSelectedIds.length})
                          </button>
                        )}
                        <button onClick={() => { setIncomeSelectMode(false); setIncomeSelectedIds([]); }}
                          style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                        İptal
                        </button>
                      </>
                    ) : (
                      <button onClick={() => setIncomeSelectMode(true)}
                        style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <rect x="3" y="3" width="18" height="18" rx="3"/>
                          <path d="M7 12l4 4 6-7"/>
                        </svg>
                        Seç
                      </button>
                    )}
                    <button className="btn-income" onClick={() => handleOpenIncomeModal()}>+ Gelir Ekle</button>
                  </div>
                </div>

                <div className="filters">
                  <input
                   type="text"
                   placeholder="İsim veya not ara..."
                   value={incomeSearch}
                   onChange={(e) => setIncomeSearch(e.target.value)}
                   className="search-input"
                   />
                  <select value={incomeFilters.payment_method} onChange={(e) => setIncomeFilters({...incomeFilters, payment_method: e.target.value})}>
                    <option value="">Tüm Ödeme Yöntemleri</option>
                    {PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                  </select>
                  <select value={incomeFilters.account_id} onChange={(e) => setIncomeFilters({...incomeFilters, account_id: e.target.value})}>
                    <option value="">Tüm Hesaplar</option>
                    {incomeAccounts.length > 0 && <option value="all-accounts" style={{fontWeight: 'bold'}}>── Tüm Gelir Hesapları ──</option>}
                    {incomeAccounts.map(a => <option key={`acc-${a.id}`} value={a.id}>&nbsp;&nbsp;&nbsp;{a.name}</option>)}
                    <option value="manual" style={{fontWeight: 'bold'}}>── Manuel Girişler ──</option>
                  </select>
                  <select value={incomeFilters.year} onChange={(e) => setIncomeFilters({...incomeFilters, year: e.target.value})}>
                    {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                  <select value={incomeFilters.month} onChange={(e) => setIncomeFilters({...incomeFilters, month: e.target.value})}>
                    <option value="">Tüm Aylar</option>
                    {MONTH_NAMES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                  </select>
                </div>

                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        {incomeSelectMode && (
                          <th style={{width:'40px'}}>
                            <input type="checkbox"
                              onChange={(e) => { const incomes = transactions.filter(t => t.transaction_type === 'income'); if (e.target.checked) setIncomeSelectedIds(incomes.map(t => t.id)); else setIncomeSelectedIds([]); }}
                              checked={incomeSelectedIds.length > 0 && incomeSelectedIds.length === transactions.filter(t => t.transaction_type === 'income').length} />
                          </th>
                        )}
                        <th>Tarih</th>
                        <th>Ödemesi Gelen</th>
                        <th>Ödeme Yöntemi</th>
                        <th>Teslim Alan (Hesap/Kasa)</th>
                        <th>Tutar</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.filter(t => t.transaction_type === 'income').length === 0 ? (
                        <tr><td colSpan="6" style={{textAlign: 'center', padding: '40px'}}>Kayıt bulunamadı</td></tr>
                      ) : (
                        transactions.filter(t => t.transaction_type === 'income').map(t => (
                          <tr key={t.id}>
                            {incomeSelectMode && (
                              <td>
                                <input type="checkbox" checked={incomeSelectedIds.includes(t.id)}
                                  onChange={(e) => { if (e.target.checked) setIncomeSelectedIds(prev => [...prev, t.id]); else setIncomeSelectedIds(prev => prev.filter(id => id !== t.id)); }} />
                              </td>
                            )}
                            <td>{formatDate(t.transaction_date)}</td>
                            <td>{t.payer_receiver || '-'}</td>
                            <td>{PAYMENT_METHODS.find(m => m.value === t.payment_method)?.label || t.payment_method}</td>
                            <td>{t.account_name || t.account_manual || '-'}</td>
                            <td className="text-success">+{formatCurrency(t.amount)}</td>
                            <td>
                              <div className="action-buttons">
                                <button className="btn-edit" onClick={() => handleOpenIncomeModal(t)}>✎</button>
                                <button className="btn-delete" onClick={() => handleDeleteTransaction(t)}>
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="3 6 5 6 21 6"/>
                                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                    <path d="M10 11v6M14 11v6"/>
                                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="summary-row">
                      <td colSpan={incomeSelectMode ? 4 : 3}><strong>TOPLAM ({transTotal} kayıt)</strong></td>
                      <td></td>
                      <td className="text-success">
                      <strong>+{transGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                      </td>
                      <td></td>
                     </tr>
                   </tfoot>
                  </table>
                  {transTotal > 0 && (
                  <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                    <select 
                      value={incomePageSize} 
                      onChange={(e) => { 
                        const newSize = Number(e.target.value);
                        setIncomePageSize(newSize); 
                        localStorage.setItem('financeIncomePageSize', newSize);
                        fetchTransactions(1, newSize); 
                      }} 
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}
                    > 
                      <option value={50}>50 kayıt</option> 
                      <option value={100}>100 kayıt</option> 
                      <option value={250}>250 kayıt</option>
                    </select>

                    <button onClick={() => fetchTransactions(1)} disabled={transPage===1}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===1?'not-allowed':'pointer', background:transPage===1?'#f5f5f5':'white'}}>«</button>
                    <button onClick={() => fetchTransactions(transPage-1)} disabled={transPage===1}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===1?'not-allowed':'pointer', background:transPage===1?'#f5f5f5':'white'}}>‹</button>
                    
                    {Array.from({length: transPages}, (_, i) => i+1)
                      .filter(p => p===1 || p===transPages || Math.abs(p-transPage)<=2)
                      .reduce((acc, p, i, arr) => {
                        if (i > 0 && p - arr[i-1] > 1) acc.push('...');
                        acc.push(p);
                        return acc;
                      }, [])
                      .map((p, i) => p==='...' ? (
                        <span key={`dots-${i}`} style={{padding:'6px 4px'}}>...</span>
                      ) : (
                        <button key={p} onClick={() => fetchTransactions(p)}
                          style={{padding:'6px 12px', borderRadius:'6px',
                            border:`1px solid ${transPage===p?'#667eea':'#ddd'}`,
                            background:transPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white',
                            color:transPage===p?'white':'#333',
                            cursor:'pointer', fontWeight:transPage===p?'600':'normal'}}>
                          {p}
                        </button>
                      ))
                    }
                    
                    <button onClick={() => fetchTransactions(transPage+1)} disabled={transPage===transPages}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===transPages?'not-allowed':'pointer', background:transPage===transPages?'#f5f5f5':'white'}}>›</button>
                    <button onClick={() => fetchTransactions(transPages)} disabled={transPage===transPages}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===transPages?'not-allowed':'pointer', background:transPage===transPages?'#f5f5f5':'white'}}>»</button>
                    
                    <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>
                    {((transPage - 1) * incomePageSize) + 1}-{Math.min(transPage * incomePageSize, transTotal)} / {transTotal} kayıt | Sayfa {transPage} / {transPages}
                  </span>
                  </div>
                )}
                </div>
              </>
            )}

            {/* ===== GİDERLER ===== */}
            {cashSubTab === 'expenses' && (
              <>
                <div className="page-header">
                  <h2>Giderler</h2>
                  <div className="header-actions">
                  <button className="btn-excel" onClick={exportExpensesToExcel}>📥 Excel</button>
                  {expenseSelectMode ? (
                    <>
                      {expenseSelectedIds.length > 0 && (
                        <button onClick={handleBulkDeleteExpenses}
                          style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                          Seçilenleri Sil ({expenseSelectedIds.length})
                        </button>
                      )}
                      <button onClick={() => { setExpenseSelectMode(false); setExpenseSelectedIds([]); }}
                        style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                        İptal
                      </button>
                    </>
                  ) : (
                    <button onClick={() => setExpenseSelectMode(true)}
                      style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <rect x="3" y="3" width="18" height="18" rx="3"/>
                          <path d="M7 12l4 4 6-7"/>
                        </svg>
                        Seç
                    </button>
                  )}
                  <button className="btn-expense" onClick={() => handleOpenExpenseModal()}>+ Gider Ekle</button>
                </div>
                </div>

                <div className="filters">
                  <input
                  type="text"
                  placeholder="İsim veya açıklama ara..."
                  value={expenseSearch}
                  onChange={(e) => setExpenseSearch(e.target.value)}
                  className="search-input"
                    />
                  <select value={expenseFilters.payment_method} onChange={(e) => setExpenseFilters({...expenseFilters, payment_method: e.target.value})}>
                    <option value="">Tüm Ödeme Yöntemleri</option>
                    {PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                  </select>
                  <select value={expenseFilters.category_id} onChange={(e) => setExpenseFilters({...expenseFilters, category_id: e.target.value})}>
                    <option value="">Tüm Kategoriler</option>
                    {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <select value={expenseFilters.account_id} onChange={(e) => setExpenseFilters({...expenseFilters, account_id: e.target.value})}>
                    <option value="">Tüm Hesaplar/Kartlar</option>
                    {expenseAccounts.length > 0 && <option value="all-accounts" style={{fontWeight: 'bold'}}>── Tüm Gider Hesapları ──</option>}
                    {expenseAccounts.map(a => <option key={`acc-${a.id}`} value={`acc-${a.id}`}>&nbsp;&nbsp;&nbsp;{a.name}</option>)}
                    {expenseCards.length > 0 && <option value="all-cards" style={{fontWeight: 'bold'}}>── Tüm Kartlar ──</option>}
                    {expenseCards.map(c => <option key={`card-${c.id}`} value={`card-${c.id}`}>&nbsp;&nbsp;&nbsp;{c.name}</option>)}
                    <option value="manual" style={{fontWeight: 'bold'}}>── Manuel Girişler ──</option>
                  </select>
                  <select value={expenseFilters.year} onChange={(e) => setExpenseFilters({...expenseFilters, year: e.target.value})}>
                    {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                  <select value={expenseFilters.month} onChange={(e) => setExpenseFilters({...expenseFilters, month: e.target.value})}>
                    <option value="">Tüm Aylar</option>
                    {MONTH_NAMES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                  </select>
                </div>

                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        {expenseSelectMode && (
                          <th style={{width:'40px'}}>
                            <input type="checkbox"
                              onChange={(e) => { const expenses = transactions.filter(t => t.transaction_type === 'expense'); if (e.target.checked) setExpenseSelectedIds(expenses.map(t => t.id)); else setExpenseSelectedIds([]); }}
                              checked={expenseSelectedIds.length > 0 && expenseSelectedIds.length === transactions.filter(t => t.transaction_type === 'expense').length} />
                          </th>
                        )}
                        <th>Tarih</th>
                        <th>Ödemesi Yapılan</th>
                        <th>Kategori</th>
                        <th>Ödeme Yöntemi</th>
                        <th>Ödeyen (Hesap/Kasa)</th>
                        <th>Tutar</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.filter(t => t.transaction_type === 'expense').length === 0 ? (
                        <tr><td colSpan="7" style={{textAlign: 'center', padding: '40px'}}>Kayıt bulunamadı</td></tr>
                      ) : (
                        transactions.filter(t => t.transaction_type === 'expense').map(t => (
                          <tr key={t.id}>
                            {expenseSelectMode && (
                              <td>
                                <input type="checkbox" checked={expenseSelectedIds.includes(t.id)}
                                  onChange={(e) => { if (e.target.checked) setExpenseSelectedIds(prev => [...prev, t.id]); else setExpenseSelectedIds(prev => prev.filter(id => id !== t.id)); }} />
                              </td>
                            )}
                            <td>{formatDate(t.transaction_date)}</td>
                            <td>{t.payer_receiver || '-'}</td>
                            <td>{t.category_name || '-'}</td>
                            <td>{PAYMENT_METHODS.find(m => m.value === t.payment_method)?.label || t.payment_method}</td>
                            <td>{t.account_name || t.card_name || t.account_manual || '-'}</td>
                            <td className="text-danger">-{formatCurrency(t.amount)}</td>
                            <td>
                              <div className="action-buttons">
                                <button className="btn-edit" onClick={() => handleOpenExpenseModal(t)}>✎</button>
                                <button className="btn-delete" onClick={() => handleDeleteTransaction(t)}>
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="3 6 5 6 21 6"/>
                                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                    <path d="M10 11v6M14 11v6"/>
                                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                  </svg>
                                  </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                     <tr className="summary-row">
                     <td colSpan={expenseSelectMode ? 5 : 4}><strong>TOPLAM ({transTotal} kayıt)</strong></td>
                     <td></td>
                     <td className="text-danger">
                     <strong>-{transGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                     </td>
                     <td></td>
                     </tr>
                   </tfoot>
                  </table>
                  {transTotal > 0 && (
                  <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                   <select 
                      value={expensePageSize} 
                      onChange={(e) => { 
                        const newSize = Number(e.target.value);
                        setExpensePageSize(newSize); 
                        localStorage.setItem('financeExpensePageSize', newSize);
                        fetchTransactions(1, newSize); 
                      }} 
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}
                    > 
                      <option value={50}>50 kayıt</option> 
                      <option value={100}>100 kayıt</option> 
                      <option value={250}>250 kayıt</option>
                    </select>

                    <button onClick={() => fetchTransactions(1)} disabled={transPage===1}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===1?'not-allowed':'pointer', background:transPage===1?'#f5f5f5':'white'}}>«</button>
                    <button onClick={() => fetchTransactions(transPage-1)} disabled={transPage===1}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===1?'not-allowed':'pointer', background:transPage===1?'#f5f5f5':'white'}}>‹</button>
                    
                    {Array.from({length: transPages}, (_, i) => i+1)
                      .filter(p => p===1 || p===transPages || Math.abs(p-transPage)<=2)
                      .reduce((acc, p, i, arr) => {
                        if (i > 0 && p - arr[i-1] > 1) acc.push('...');
                        acc.push(p);
                        return acc;
                      }, [])
                      .map((p, i) => p==='...' ? (
                        <span key={`dots-${i}`} style={{padding:'6px 4px'}}>...</span>
                      ) : (
                        <button key={p} onClick={() => fetchTransactions(p)}
                          style={{padding:'6px 12px', borderRadius:'6px',
                            border:`1px solid ${transPage===p?'#667eea':'#ddd'}`,
                            background:transPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white',
                            color:transPage===p?'white':'#333',
                            cursor:'pointer', fontWeight:transPage===p?'600':'normal'}}>
                          {p}
                        </button>
                      ))
                    }
                    
                    <button onClick={() => fetchTransactions(transPage+1)} disabled={transPage===transPages}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===transPages?'not-allowed':'pointer', background:transPage===transPages?'#f5f5f5':'white'}}>›</button>
                    <button onClick={() => fetchTransactions(transPages)} disabled={transPage===transPages}
                      style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transPage===transPages?'not-allowed':'pointer', background:transPage===transPages?'#f5f5f5':'white'}}>»</button>
                    
                    <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>
                    {((transPage - 1) * expensePageSize) + 1}-{Math.min(transPage * expensePageSize, transTotal)} / {transTotal} kayıt | Sayfa {transPage} / {transPages}
                  </span>
                  </div>
                )}
                </div>
              </>
            )}

{/* ===== KART GİDERLERİ ===== */}
            {cashSubTab === 'card_expenses' && (
              <>
                <div className="page-header">
                  <h2>Kart Giderleri</h2>
                  <div className="header-actions">
                    <button className="btn-excel" onClick={exportCardExpensesToExcel}>📥 Excel</button>
                    {cardExpSelectMode ? (
                      <>
                        {cardExpSelectedIds.length > 0 && (
                          <button onClick={handleBulkDeleteCardExpenses}
                            style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                          Seçilenleri Sil ({cardExpSelectedIds.length})
                          </button>
                        )}
                        <button onClick={() => { setCardExpSelectMode(false); setCardExpSelectedIds([]); }}
                          style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                              <path d="M18 6L6 18M6 6l12 12"/>
                            </svg>
                            İptal
                          </button>
                      </>
                    ) : (
                      <button onClick={() => setCardExpSelectMode(true)}
                        style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <rect x="3" y="3" width="18" height="18" rx="3"/>
                            <path d="M7 12l4 4 6-7"/>
                          </svg>
                          Seç
                        </button>
                    )}
                    <button className="btn-expense" onClick={() => handleOpenCardExpenseModal()}>+ Kart Gideri Ekle</button>
                  </div>
                </div>

                <div className="filters">
                  <input type="text" placeholder="Ödeme yapılan yer veya not ara..." value={cardExpSearch}
                    onChange={(e) => setCardExpSearch(e.target.value)} className="search-input" />
                  <select value={cardExpFilters.card_id} onChange={(e) => setCardExpFilters({...cardExpFilters, card_id: e.target.value})}>
                    <option value="">Tüm Kartlar</option>
                    {expenseCards.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <select value={cardExpFilters.year} onChange={(e) => setCardExpFilters({...cardExpFilters, year: e.target.value})}>
                    {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                  <select value={cardExpFilters.month} onChange={(e) => setCardExpFilters({...cardExpFilters, month: e.target.value})}>
                    <option value="">Tüm Aylar</option>
                    {MONTH_NAMES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                  </select>
                </div>

                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        {cardExpSelectMode && (
                          <th style={{width:'40px'}}>
                            <input type="checkbox"
                              onChange={(e) => { if (e.target.checked) setCardExpSelectedIds(cardExpenses.map(t => t.id)); else setCardExpSelectedIds([]); }}
                              checked={cardExpSelectedIds.length === cardExpenses.length && cardExpenses.length > 0} />
                          </th>
                        )}
                        <th>Tarih</th>
                        <th>Kullanılan Kart</th>
                        <th>Ödeme Yapılan Yer</th>
                        <th>Tutar</th>
                        <th>Ödeme Şekli</th>
                        <th>Taksit Sayısı</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cardExpenses.length === 0 ? (
                        <tr><td colSpan={cardExpSelectMode ? 8 : 7} style={{textAlign:'center', padding:'40px'}}>Kayıt bulunamadı</td></tr>
                      ) : (
                        cardExpenses.map(t => (
                          <tr key={t.id}>
                            {cardExpSelectMode && (
                              <td>
                                <input type="checkbox" checked={cardExpSelectedIds.includes(t.id)}
                                  onChange={(e) => { if (e.target.checked) setCardExpSelectedIds(prev => [...prev, t.id]); else setCardExpSelectedIds(prev => prev.filter(id => id !== t.id)); }} />
                              </td>
                            )}
                            <td>{formatDate(t.transaction_date)}</td>
                            <td>{t.card_name || '-'}</td>
                            <td>{t.payer_receiver || '-'}</td>
                            <td className="text-danger">-{formatCurrency(t.amount)}</td>
                            <td>
                              <span className={`badge ${t.is_installment ? 'badge-warning' : 'badge-success'}`}>
                                {t.is_installment ? 'Taksitli' : 'Tek Çekim'}
                              </span>
                            </td>
                            <td>{t.is_installment && t.installment_count ? `${t.installment_count} Taksit` : '-'}</td>
                            <td>
                              <div className="action-buttons">
                                <button className="btn-edit" onClick={() => handleOpenCardExpenseModal(t)}>✎</button>
                                <button className="btn-delete" onClick={() => handleDeleteCardExpense(t)}>
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="3 6 5 6 21 6"/>
                                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                    <path d="M10 11v6M14 11v6"/>
                                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                  </svg>
                                  </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="summary-row">
                        <td colSpan={cardExpSelectMode ? 4 : 3}><strong>TOPLAM ({cardExpTotal} kayıt)</strong></td>
                        <td className="text-danger"><strong>-{cardExpGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                        <td colSpan={cardExpSelectMode ? 4 : 3}></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                {cardExpTotal > 0 && (
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                  <select value={cardExpPageSize} onChange={(e) => { const s = Number(e.target.value); setCardExpPageSize(s); localStorage.setItem('financeCardExpPageSize', s); fetchCardExpenses(1, s); }}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}>
                    <option value={50}>50 kayıt</option><option value={100}>100 kayıt</option><option value={250}>250 kayıt</option>
                  </select>
                  <button onClick={() => fetchCardExpenses(1)} disabled={cardExpPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:cardExpPage===1?'not-allowed':'pointer', background:cardExpPage===1?'#f5f5f5':'white'}}>«</button>
                  <button onClick={() => fetchCardExpenses(cardExpPage-1)} disabled={cardExpPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:cardExpPage===1?'not-allowed':'pointer', background:cardExpPage===1?'#f5f5f5':'white'}}>‹</button>
                  {Array.from({length: cardExpPages}, (_, i) => i+1).filter(p => p===1 || p===cardExpPages || Math.abs(p-cardExpPage)<=2).reduce((acc, p, i, arr) => { if (i > 0 && p - arr[i-1] > 1) acc.push('...'); acc.push(p); return acc; }, []).map((p, i) => p==='...' ? <span key={`cedots-${i}`} style={{padding:'6px 4px'}}>...</span> : <button key={`ce-${p}`} onClick={() => fetchCardExpenses(p)} style={{padding:'6px 12px', borderRadius:'6px', border:`1px solid ${cardExpPage===p?'#667eea':'#ddd'}`, background:cardExpPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white', color:cardExpPage===p?'white':'#333', cursor:'pointer', fontWeight:cardExpPage===p?'600':'normal'}}>{p}</button>)}
                  <button onClick={() => fetchCardExpenses(cardExpPage+1)} disabled={cardExpPage===cardExpPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:cardExpPage===cardExpPages?'not-allowed':'pointer', background:cardExpPage===cardExpPages?'#f5f5f5':'white'}}>›</button>
                  <button onClick={() => fetchCardExpenses(cardExpPages)} disabled={cardExpPage===cardExpPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:cardExpPage===cardExpPages?'not-allowed':'pointer', background:cardExpPage===cardExpPages?'#f5f5f5':'white'}}>»</button>
                  <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>{((cardExpPage-1)*cardExpPageSize)+1}-{Math.min(cardExpPage*cardExpPageSize, cardExpTotal)} / {cardExpTotal} kayıt | Sayfa {cardExpPage} / {cardExpPages}</span>
                </div>
                )}
              </>
            )}

{/* ===== CİRO/TRANSFER ===== */}
{cashSubTab === 'transfers' && (
  <>
    <div className="page-header">
      <h2>Ciro / Transfer</h2>
      <div className="header-actions">
      <button className="btn-excel" onClick={exportTransfersToExcel}>📥 Excel</button>
      {transferSelectMode ? (
        <>
          {transferSelectedIds.length > 0 && (
            <button onClick={handleBulkDeleteTransfers}
              style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#ff5252,#d32f2f)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                        >
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                            <path d="M10 11v6M14 11v6"/>
                            <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                          </svg>
                          Seçilenleri Sil ({transferSelectedIds.length})
            </button>
          )}
          <button onClick={() => { setTransferSelectMode(false); setTransferSelectedIds([]); }}
            style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                        İptal
          </button>
        </>
      ) : (
        <button onClick={() => setTransferSelectMode(true)}
          style={{display:'flex', alignItems:'center', gap:'6px', padding:'10px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'550'}}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <rect x="3" y="3" width="18" height="18" rx="3"/>
                          <path d="M7 12l4 4 6-7"/>
                        </svg>
                        Seç
         </button>
      )}
      <button className="btn-primary" onClick={() => handleOpenTransferModal()}>+ Transfer Ekle</button>
    </div>
    </div>

    <div className="filters">
      <input
      type="text"
      placeholder="Kaynak ara..."
      value={transferSourceSearch}
      onChange={(e) => setTransferSourceSearch(e.target.value)}
      className="search-input"
      />
      <input
      type="text"
      placeholder="Hedef ara..."
      value={transferTargetSearch}
      onChange={(e) => setTransferTargetSearch(e.target.value)}
      className="search-input"
      />
      <select value={transferFilters.transfer_type} onChange={(e) => setTransferFilters({...transferFilters, transfer_type: e.target.value})}>
        <option value="">Tüm Transfer Tipleri</option>
        {TRANSFER_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
      </select>
      <select value={transferFilters.year} onChange={(e) => setTransferFilters({...transferFilters, year: e.target.value})}>
        {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
      </select>
      <select value={transferFilters.month} onChange={(e) => setTransferFilters({...transferFilters, month: e.target.value})}>
        <option value="">Tüm Aylar</option>
        {MONTH_NAMES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
      </select>
    </div>

    <div className="finance-summary-cards">
      <div className="finance-card"><span className="card-label">Çek</span><span className="card-value">{transferGrandTotalCek.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
      <div className="finance-card"><span className="card-label">Kredi Kartı</span><span className="card-value">{transferGrandTotalKredi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
      <div className="finance-card"><span className="card-label">Nakit/Havale</span><span className="card-value">{transferGrandTotalNakit.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
      <div className="finance-card income"><span className="card-label">Toplam</span><span className="card-value">{transferGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>    </div>

    <div className="table-container">
      <table>
        <thead>
          <tr>
            {transferSelectMode && (
              <th style={{width:'40px'}}>
                <input type="checkbox"
                  onChange={(e) => { if (e.target.checked) setTransferSelectedIds(transfers.map(t => t.id)); else setTransferSelectedIds([]); }}
                  checked={transferSelectedIds.length === transfers.length && transfers.length > 0} />
              </th>
            )}
            <th>Tarih</th><th>Tip</th><th>Kaynak</th><th>Hedef</th><th>Tutar</th><th>Çek No</th><th>Vade</th><th>İşlemler</th></tr>
        </thead>
        <tbody>
          {transfers.length === 0 ? (
            <tr><td colSpan="8" style={{textAlign: 'center', padding: '40px'}}>Kayıt bulunamadı</td></tr>
          ) : (
            transfers.map(t => (
              <tr key={t.id}>
                {transferSelectMode && (
                  <td>
                    <input type="checkbox" checked={transferSelectedIds.includes(t.id)}
                      onChange={(e) => { if (e.target.checked) setTransferSelectedIds(prev => [...prev, t.id]); else setTransferSelectedIds(prev => prev.filter(id => id !== t.id)); }} />
                  </td>
                )}
                <td>{formatDate(t.transfer_date)}</td>
                <td><span className={`badge badge-${t.transfer_type === 'cek' ? 'warning' : 'info'}`}>{TRANSFER_TYPES.find(tt => tt.value === t.transfer_type)?.label}</span></td>
                <td>{t.source_type === 'supplier' ? t.source_supplier_name : t.source_type === 'account' ? t.source_account_name : t.source_name}</td>
                <td>{t.target_type === 'supplier' ? t.target_supplier_name : t.target_type === 'account' ? t.target_account_name : t.target_name}</td>
                <td className="text-primary"><strong>{formatCurrency(t.amount)}</strong></td>
                <td>{t.check_no || '-'}</td>
                <td>{t.check_due_date ? formatDate(t.check_due_date) : '-'}</td>
                <td>
                  <div className="action-buttons">
                    <button className="btn-edit" onClick={() => handleOpenTransferModal(t)}>✎</button>
                    <button className="btn-delete" onClick={() => handleDeleteTransfer(t)}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                        <path d="M10 11v6M14 11v6"/>
                        <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                      </svg>
                      </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
        {transferTotal > 0 && (
              <tfoot>
                <tr className="summary-row">
                  <td colSpan={transferSelectMode ? 5 : 4}><strong>TOPLAM ({transferTotal} kayıt)</strong></td>
                  <td className="text-primary"><strong>{transferGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                  <td colSpan="3"></td>
                </tr>
              </tfoot>
            )}
                  </table>
                </div>
                {transferTotal > 0 && (
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                  <select 
                    value={transferPageSize} 
                    onChange={(e) => { 
                      const newSize = Number(e.target.value);
                      setTransferPageSize(newSize); 
                      localStorage.setItem('financeTransferPageSize', newSize);
                      fetchTransfers(1, newSize); 
                    }} 
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}
                  > 
                    <option value={50}>50 kayıt</option> 
                    <option value={100}>100 kayıt</option> 
                    <option value={250}>250 kayıt</option>
                  </select>

                  <button onClick={() => fetchTransfers(1)} disabled={transferPage===1}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transferPage===1?'not-allowed':'pointer', background:transferPage===1?'#f5f5f5':'white'}}>«</button>
                  <button onClick={() => fetchTransfers(transferPage-1)} disabled={transferPage===1}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transferPage===1?'not-allowed':'pointer', background:transferPage===1?'#f5f5f5':'white'}}>‹</button>
                  
                  {Array.from({length: transferPages}, (_, i) => i+1)
                    .filter(p => p===1 || p===transferPages || Math.abs(p-transferPage)<=2)
                    .reduce((acc, p, i, arr) => {
                      if (i > 0 && p - arr[i-1] > 1) acc.push('...');
                      acc.push(p);
                      return acc;
                    }, [])
                    .map((p, i) => p==='...' ? (
                      <span key={`dots-${i}`} style={{padding:'6px 4px'}}>...</span>
                    ) : (
                      <button key={p} onClick={() => fetchTransfers(p)}
                        style={{padding:'6px 12px', borderRadius:'6px',
                          border:`1px solid ${transferPage===p?'#667eea':'#ddd'}`,
                          background:transferPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white',
                          color:transferPage===p?'white':'#333',
                          cursor:'pointer', fontWeight:transferPage===p?'600':'normal'}}>
                        {p}
                      </button>
                    ))
                  }
                  
                  <button onClick={() => fetchTransfers(transferPage+1)} disabled={transferPage===transferPages}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transferPage===transferPages?'not-allowed':'pointer', background:transferPage===transferPages?'#f5f5f5':'white'}}>›</button>
                  <button onClick={() => fetchTransfers(transferPages)} disabled={transferPage===transferPages}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:transferPage===transferPages?'not-allowed':'pointer', background:transferPage===transferPages?'#f5f5f5':'white'}}>»</button>
                  
                  <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>
                    {((transferPage - 1) * transferPageSize) + 1}-{Math.min(transferPage * transferPageSize, transferTotal)} / {transferTotal} kayıt | Sayfa {transferPage} / {transferPages}
                  </span>
                </div>
              )}
              </>
            )}
            {/* ===== RAPORLAR ===== */}
            {cashSubTab === 'reports' && (
              <>
                <div className="page-header">
                  <h2>Kasa Raporu</h2>
                  <div className="header-actions">
                    <button className="btn-excel" onClick={exportReportToExcel}>📥 Excel</button>
                  </div>
                </div>

                <div className="filters">
                  <select value={reportFilters.year} onChange={(e) => setReportFilters({...reportFilters, year: e.target.value})}>
                    {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>

                {cashReportData && (
  <>
    <div className="finance-summary-cards">
      <div className="finance-card income">
        <span className="card-label">Toplam Gelir</span>
        <span className="card-value">{cashReportData.summary.total_income.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span>
      </div>
      <div className="finance-card expense">
        <span className="card-label">Toplam Gider</span>
        <span className="card-value">{cashReportData.summary.total_expense.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span>
      </div>
      <div className={`finance-card ${cashReportData.summary.net >= 0 ? 'positive' : 'negative'}`}>
        <span className="card-label">Net</span>
        <span className="card-value">{cashReportData.summary.net.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span>
      </div>
    </div>

    <div className="table-container">
      <table>
        <thead>
          <tr><th>Ay</th><th>Gelir</th><th>Gider</th><th>Net</th></tr>
        </thead>
        <tbody>
          {cashReportData.monthly.map(m => (
            <tr key={m.month}>
              <td><strong>{m.month_name}</strong></td>
              <td className="text-success">{m.income.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
              <td className="text-danger">{m.expense.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
              <td className={m.net >= 0 ? 'text-success' : 'text-danger'}>{m.net.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="summary-row">
            <td><strong>TOPLAM</strong></td>
            <td className="text-success"><strong>{cashReportData.summary.total_income.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
            <td className="text-danger"><strong>{cashReportData.summary.total_expense.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
            <td className={cashReportData.summary.net >= 0 ? 'text-success' : 'text-danger'}>
              <strong>{cashReportData.summary.net.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                </td>
                    </tr>
                  </tfoot>
                 </table>
                </div>
                </>
               )}
              </>
            )}

            {/* ===== AYARLAR - 4'LÜ GRİD ===== */}
            {cashSubTab === 'settings' && (
              <div className="settings-grid-4">
                {/* Gelir Hesapları */}
                <div className="settings-section">
                  <div className="section-header">
                    <h3>💰 Gelir Hesapları</h3>
                    <button className="btn-sm btn-primary" onClick={() => setIsIncomeAccountModalOpen(true)}>+ Ekle</button>
                  </div>
                  <div className="settings-list">
                    {incomeAccounts.map(a => (
                      <div key={a.id} className="settings-item">
                        <span>{a.name}</span>
                        <div className="settings-item-actions">
                          <span className="badge badge-success">{a.account_type}</span>
                          <button className="btn-delete-sm" onClick={() => handleDeleteAccountByType(a, 'income')}>✕</button>
                        </div>
                      </div>
                    ))}
                    {incomeAccounts.length === 0 && <div className="settings-item empty">Henüz hesap eklenmemiş</div>}
                  </div>
                </div>

                {/* Gider Hesapları */}
                <div className="settings-section">
                  <div className="section-header">
                    <h3>💸 Gider Hesapları</h3>
                    <button className="btn-sm btn-primary" onClick={() => setIsExpenseAccountModalOpen(true)}>+ Ekle</button>
                  </div>
                  <div className="settings-list">
                    {expenseAccounts.map(a => (
                      <div key={a.id} className="settings-item">
                        <span>{a.name}</span>
                        <div className="settings-item-actions">
                          <span className="badge badge-danger">{a.account_type}</span>
                          <button className="btn-delete-sm" onClick={() => handleDeleteAccountByType(a, 'expense')}>✕</button>
                        </div>
                      </div>
                    ))}
                    {expenseAccounts.length === 0 && <div className="settings-item empty">Henüz hesap eklenmemiş</div>}
                  </div>
                </div>

                {/* Gider Kartları */}
                <div className="settings-section">
                  <div className="section-header">
                    <h3>💳 Gider Kartları</h3>
                    <button className="btn-sm btn-primary" onClick={() => setIsExpenseCardModalOpen(true)}>+ Ekle</button>
                  </div>
                  <div className="settings-list">
                    {expenseCards.map(c => (
                      <div key={c.id} className="settings-item">
                        <span>{c.name}</span>
                        <div className="settings-item-actions">
                          <span className="badge badge-info">{c.notes || 'Kart'}</span>
                          <button className="btn-delete-sm" onClick={() => handleDeleteAccountByType(c, 'card')}>✕</button>
                        </div>
                      </div>
                    ))}
                    {expenseCards.length === 0 && <div className="settings-item empty">Henüz kart eklenmemiş</div>}
                  </div>
                </div>

                {/* Kategoriler */}
                <div className="settings-section">
                  <div className="section-header">
                    <h3>📁 Gider Kategorileri</h3>
                    <button className="btn-sm btn-primary" onClick={() => setIsCategoryModalOpen(true)}>+ Ekle</button>
                  </div>
                  <div className="settings-list">
                    {categories.map(c => (
                      <div key={c.id} className="settings-item">
                        <span>{c.name}</span>
                        <button className="btn-delete-sm" onClick={() => handleDeleteCategory(c)}>✕</button>
                      </div>
                    ))}
                    {categories.length === 0 && <div className="settings-item empty">Henüz kategori eklenmemiş</div>}
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {/* ==================== TEDARİKÇİ BORÇ TAKİBİ TAB ==================== */}
        {activeMainTab === 'suppliers' && (
          <>
            <div className="finance-sub-tabs">
              <button className={supplierSubTab === 'list' ? 'active' : ''} onClick={() => { setSupplierSubTab('list'); setSelectedSupplier(null); }}>📋 Tedarikçiler</button>
              {selectedSupplier && (
                <button className={supplierSubTab === 'ledger' ? 'active' : ''} onClick={() => setSupplierSubTab('ledger')}>📊 {selectedSupplier.name}</button>
              )}
              <button className={supplierSubTab === 'summary' ? 'active' : ''} onClick={() => setSupplierSubTab('summary')}>📊 Özet Rapor</button>
            </div>

            {/* Tedarikçi Listesi */}
            {supplierSubTab === 'list' && (
              <>
                <div className="page-header">
                  <h2>Tedarikçiler ({supplierTotal})</h2>
                  <div className="header-actions">
                    <button className="btn-excel" onClick={exportSuppliersToExcel}>📥 Excel</button>
                    <button className="btn-primary" onClick={() => handleOpenSupplierModal()}>+ Yeni Tedarikçi</button>
                  </div>
                </div>
                
                <div className="filters">
                  <input
                    type="text"
                    placeholder="Tedarikçi adı, kişi veya telefon ara..."
                    value={supplierSearch}
                    onChange={(e) => setSupplierSearch(e.target.value)}
                    className="search-input"
                  />
                </div>

                <div className="table-container">
                  <table className="suppliers-table">
                    <thead>
                      <tr><th>Firma Adı</th><th>İlgili Kişi</th><th>Telefon</th><th>Bakiye</th><th>İşlemler</th></tr>
                    </thead>
                    <tbody>
                      {suppliers.map(s => (
                        <tr key={s.id}>
                          <td title={`#${s.id}`}><strong className="supplier-link" onClick={() => handleSelectSupplier(s)}>{s.name}</strong></td>
                          <td>{s.contact_person || '-'}</td>
                          <td>{s.phone || '-'}</td>
                          <td><span className={`badge ${s.total_debt > 0 ? 'badge-danger' : 'badge-success'}`}>{(s.total_debt || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></td>
                          <td>
                            <div className="action-buttons">
                              <button className="btn-view" onClick={() => handleSelectSupplier(s)}>📊</button>
                              <button className="btn-edit" onClick={() => handleOpenSupplierModal(s)}>✎</button>
                              <button className="btn-delete" onClick={() => handleDeleteSupplier(s)}>
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                  <polyline points="3 6 5 6 21 6"/>
                                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                  <path d="M10 11v6M14 11v6"/>
                                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                </svg>
                                </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {supplierTotal > 0 && (
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                  <select value={supplierPageSize} onChange={(e) => { const s = Number(e.target.value); setSupplierPageSize(s); localStorage.setItem('financeSupplierPageSize', s); fetchSuppliers(1, s); }}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}>
                    <option value={50}>50 kayıt</option><option value={100}>100 kayıt</option><option value={250}>250 kayıt</option>
                  </select>
                  <button onClick={() => fetchSuppliers(1)} disabled={supplierPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:supplierPage===1?'not-allowed':'pointer', background:supplierPage===1?'#f5f5f5':'white'}}>«</button>
                  <button onClick={() => fetchSuppliers(supplierPage-1)} disabled={supplierPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:supplierPage===1?'not-allowed':'pointer', background:supplierPage===1?'#f5f5f5':'white'}}>‹</button>
                  {Array.from({length: supplierPages}, (_, i) => i+1).filter(p => p===1 || p===supplierPages || Math.abs(p-supplierPage)<=2).reduce((acc, p, i, arr) => { if (i > 0 && p - arr[i-1] > 1) acc.push('...'); acc.push(p); return acc; }, []).map((p, i) => p==='...' ? <span key={`dots-${i}`} style={{padding:'6px 4px'}}>...</span> : <button key={p} onClick={() => fetchSuppliers(p)} style={{padding:'6px 12px', borderRadius:'6px', border:`1px solid ${supplierPage===p?'#667eea':'#ddd'}`, background:supplierPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white', color:supplierPage===p?'white':'#333', cursor:'pointer', fontWeight:supplierPage===p?'600':'normal'}}>{p}</button>)}
                  <button onClick={() => fetchSuppliers(supplierPage+1)} disabled={supplierPage===supplierPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:supplierPage===supplierPages?'not-allowed':'pointer', background:supplierPage===supplierPages?'#f5f5f5':'white'}}>›</button>
                  <button onClick={() => fetchSuppliers(supplierPages)} disabled={supplierPage===supplierPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:supplierPage===supplierPages?'not-allowed':'pointer', background:supplierPage===supplierPages?'#f5f5f5':'white'}}>»</button>
                  <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>{((supplierPage-1)*supplierPageSize)+1}-{Math.min(supplierPage*supplierPageSize, supplierTotal)} / {supplierTotal} tedarikçi | Sayfa {supplierPage} / {supplierPages}</span>
                </div>
                )}
              </>
            )}

            {/* Cari Hesap */}
            {supplierSubTab === 'ledger' && selectedSupplier && ledgerData && (
              <>
                <div className="page-header">
                  <h2>{selectedSupplier.name} - Cari Hesap ({ledgerYear})</h2>
                  <div className="header-actions">
                    <select value={ledgerYear} onChange={(e) => setLedgerYear(parseInt(e.target.value))} className="year-select">
                      {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                    <button className="btn-excel" onClick={exportLedgerToExcel}>📥 Excel</button>
                    <button className="btn-warning btn-wide" onClick={() => handleOpenInvoiceModal()}>+ Fatura / Malzeme</button>
                    <button className="btn-income btn-wide" onClick={() => handleOpenPaymentModal()}>+ Ödeme</button>
                  </div>
                </div>

                <div className="finance-summary-cards four">
                  <div className="finance-card"><span className="card-label">Geçen Yıldan Devir</span><span className="card-value">{ledgerData.opening_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                  <div className="finance-card warning"><span className="card-label">Yıl İçi Alınan</span><span className="card-value">{ledgerData.total_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                  <div className="finance-card income"><span className="card-label">Yıl İçi Ödenen</span><span className="card-value">{ledgerData.total_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                  <div className={`finance-card ${ledgerData.closing_balance > 0 ? 'expense' : 'income'}`}><span className="card-label">Kalan Bakiye</span><span className="card-value">{ledgerData.closing_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                </div>

                <h3 style={{marginTop: '30px', marginBottom: '15px'}}>📅 Aylık Özet</h3>
                <div className="table-container">
                  <table>
                    <thead>
                      <tr><th>Ay</th><th>Devir</th><th>Alınan</th><th>Nakit/Havale</th><th>Kart</th><th>Çek</th><th>Toplam Ödeme</th><th>Kalan</th></tr>
                    </thead>
                  <tbody>
                {ledgerData.monthly.map(m => {
                const currentYear = new Date().getFullYear();
                const currentMonth = new Date().getMonth() + 1;
    
                // Gelecek ay VE işlem yoksa 0 göster
                const isFutureWithNoData = (ledgerYear > currentYear || (ledgerYear === currentYear && m.month > currentMonth)) 
                && m.total_invoices === 0 && m.total_payments === 0;
    
                // Devir: Eğer gelecek ayda işlem yoksa 0, varsa veya geçmiş aysa normal devir
                const displayOpening = isFutureWithNoData ? 0 : m.opening_balance;
                const displayClosing = isFutureWithNoData ? 0 : m.closing_balance;
    
                return (
               <tr key={m.month} className={isFutureWithNoData ? 'future-month' : ''}>
               <td><strong>{m.month_name}</strong></td>
               <td>{displayOpening.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
               <td className="text-warning">{m.total_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
               <td className="text-success">{m.payment_cash.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
               <td className="text-success">{m.payment_card.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
               <td className="text-success">{m.payment_check.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
               <td className="text-success"><strong>{m.total_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
               <td className={displayClosing > 0 ? 'text-danger' : 'text-success'}>
              <strong>{displayClosing.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
               </td>
               </tr>
                );
           })}
                  </tbody>
                  <tfoot>
                <tr className="summary-row">
                <td><strong>TOPLAM</strong></td>
                <td>{ledgerData.opening_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                <td className="text-warning"><strong>{ledgerData.total_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                <td className="text-success"><strong>{ledgerData.monthly.reduce((sum, m) => sum + m.payment_cash, 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                <td className="text-success"><strong>{ledgerData.monthly.reduce((sum, m) => sum + m.payment_card, 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                <td className="text-success"><strong>{ledgerData.monthly.reduce((sum, m) => sum + m.payment_check, 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                <td className="text-success"><strong>{ledgerData.total_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                <td className={ledgerData.closing_balance > 0 ? 'text-danger' : 'text-success'}>
                <strong>{ledgerData.closing_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                </td>
                </tr>
                  </tfoot>
                  </table>
                </div>

                <h3 style={{marginTop: '30px', marginBottom: '15px'}}>📄 Faturalar / Malzemeler ({ledgerYear})</h3>
                <div className="table-container">
                  <table>
                    <thead><tr><th>Tarih</th><th>Fatura No</th><th>Açıklama</th><th>Tutar</th><th>İşlemler</th></tr></thead>
                    <tbody>
                      {invoicesList.length === 0 ? (
                        <tr><td colSpan="5" style={{textAlign: 'center', padding: '20px', color: '#999'}}>Bu yıl için fatura kaydı yok</td></tr>
                      ) : (
                        invoicesList.map(inv => (
                          <tr key={inv.id}>
                            <td>{formatDate(inv.invoice_date)}</td>
                            <td>{inv.invoice_no || '-'}</td>
                            <td>{inv.description || '-'}</td>
                            <td className="text-warning"><strong>{inv.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                            <td>
                              <div className="action-buttons">
                                <button className="btn-edit" onClick={() => handleOpenInvoiceModal(inv)}>✎</button>
                                <button className="btn-delete" onClick={() => handleDeleteInvoice(inv)}>
                                 <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                  <polyline points="3 6 5 6 21 6"/>
                                  <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                  <path d="M10 11v6M14 11v6"/>
                                  <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    {invoiceTotal > 0 && (
                    <tfoot>
                      <tr className="summary-row">
                        <td colSpan="3"><strong>TOPLAM ({invoiceTotal} fatura)</strong></td>
                        <td className="text-warning"><strong>{invoiceGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                        <td></td>
                      </tr>
                    </tfoot>
                    )}
                  </table>
                </div>
                {invoiceTotal > 0 && (
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                  <select value={invoicePageSize} onChange={(e) => { const s = Number(e.target.value); setInvoicePageSize(s); localStorage.setItem('financeInvoicePageSize', s); fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, 1, paymentPage); }}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}>
                    <option value={50}>50 kayıt</option><option value={100}>100 kayıt</option><option value={250}>250 kayıt</option>
                  </select>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, 1, paymentPage)} disabled={invoicePage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:invoicePage===1?'not-allowed':'pointer', background:invoicePage===1?'#f5f5f5':'white'}}>«</button>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage-1, paymentPage)} disabled={invoicePage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:invoicePage===1?'not-allowed':'pointer', background:invoicePage===1?'#f5f5f5':'white'}}>‹</button>
                  {Array.from({length: invoicePages}, (_, i) => i+1).filter(p => p===1 || p===invoicePages || Math.abs(p-invoicePage)<=2).reduce((acc, p, i, arr) => { if (i > 0 && p - arr[i-1] > 1) acc.push('...'); acc.push(p); return acc; }, []).map((p, i) => p==='...' ? <span key={`idots-${i}`} style={{padding:'6px 4px'}}>...</span> : <button key={`inv-${p}`} onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, p, paymentPage)} style={{padding:'6px 12px', borderRadius:'6px', border:`1px solid ${invoicePage===p?'#667eea':'#ddd'}`, background:invoicePage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white', color:invoicePage===p?'white':'#333', cursor:'pointer', fontWeight:invoicePage===p?'600':'normal'}}>{p}</button>)}
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage+1, paymentPage)} disabled={invoicePage===invoicePages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:invoicePage===invoicePages?'not-allowed':'pointer', background:invoicePage===invoicePages?'#f5f5f5':'white'}}>›</button>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePages, paymentPage)} disabled={invoicePage===invoicePages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:invoicePage===invoicePages?'not-allowed':'pointer', background:invoicePage===invoicePages?'#f5f5f5':'white'}}>»</button>
                  <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>{((invoicePage-1)*invoicePageSize)+1}-{Math.min(invoicePage*invoicePageSize, invoiceTotal)} / {invoiceTotal} kayıt | Sayfa {invoicePage} / {invoicePages}</span>
                </div>
                )}

                <h3 style={{marginTop: '30px', marginBottom: '15px'}}>💵 Ödemeler ({ledgerYear})</h3>
                <div className="table-container">
                  <table>
                    <thead><tr><th>Tarih</th><th>Ödeme Yöntemi</th><th>Referans No</th><th>Açıklama</th><th>Tutar</th><th>İşlemler</th></tr></thead>
                    <tbody>
                      {paymentsList.length === 0 ? (
                        <tr><td colSpan="6" style={{textAlign: 'center', padding: '20px', color: '#999'}}>Bu yıl için ödeme kaydı yok</td></tr>
                      ) : (
                        paymentsList.map(pay => (
                          <tr key={pay.id}>
                            <td>{formatDate(pay.payment_date)}</td>
                            <td>{SUPPLIER_PAYMENT_METHODS.find(m => m.value === pay.payment_method)?.label || pay.payment_method}</td>
                            <td>{pay.reference_no || '-'}</td>
                            <td>{pay.description || '-'}</td>
                            <td className="text-success"><strong>{pay.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                            <td>
                              <div className="action-buttons">
                                <button className="btn-edit" onClick={() => handleOpenPaymentModal(pay)}>✎</button>
                                <button className="btn-delete" onClick={() => handleDeletePayment(pay)}>
                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <polyline points="3 6 5 6 21 6"/>
                                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                                    <path d="M10 11v6M14 11v6"/>
                                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                                  </svg>
                                  </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    {paymentTotal > 0 && (
                    <tfoot>
                      <tr className="summary-row">
                        <td colSpan="4"><strong>TOPLAM ({paymentTotal} ödeme)</strong></td>
                        <td className="text-success"><strong>{paymentGrandTotal.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                        <td></td>
                      </tr>
                    </tfoot>
                    )}
                  </table>
                </div>
                {paymentTotal > 0 && (
                <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'8px', padding:'15px', flexWrap:'wrap'}}>
                  <select value={paymentPageSize} onChange={(e) => { const s = Number(e.target.value); setPaymentPageSize(s); localStorage.setItem('financePaymentPageSize', s); fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, 1); }}
                    style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', marginRight:'8px', cursor:'pointer', fontSize:'13px', background:'white'}}>
                    <option value={50}>50 kayıt</option><option value={100}>100 kayıt</option><option value={250}>250 kayıt</option>
                  </select>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, 1)} disabled={paymentPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:paymentPage===1?'not-allowed':'pointer', background:paymentPage===1?'#f5f5f5':'white'}}>«</button>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, paymentPage-1)} disabled={paymentPage===1} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:paymentPage===1?'not-allowed':'pointer', background:paymentPage===1?'#f5f5f5':'white'}}>‹</button>
                  {Array.from({length: paymentPages}, (_, i) => i+1).filter(p => p===1 || p===paymentPages || Math.abs(p-paymentPage)<=2).reduce((acc, p, i, arr) => { if (i > 0 && p - arr[i-1] > 1) acc.push('...'); acc.push(p); return acc; }, []).map((p, i) => p==='...' ? <span key={`pdots-${i}`} style={{padding:'6px 4px'}}>...</span> : <button key={`pay-${p}`} onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, p)} style={{padding:'6px 12px', borderRadius:'6px', border:`1px solid ${paymentPage===p?'#667eea':'#ddd'}`, background:paymentPage===p?'linear-gradient(135deg,#667eea,#764ba2)':'white', color:paymentPage===p?'white':'#333', cursor:'pointer', fontWeight:paymentPage===p?'600':'normal'}}>{p}</button>)}
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, paymentPage+1)} disabled={paymentPage===paymentPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:paymentPage===paymentPages?'not-allowed':'pointer', background:paymentPage===paymentPages?'#f5f5f5':'white'}}>›</button>
                  <button onClick={() => fetchInvoicesAndPayments(selectedSupplier.id, ledgerYear, invoicePage, paymentPages)} disabled={paymentPage===paymentPages} style={{padding:'6px 10px', borderRadius:'6px', border:'1px solid #ddd', cursor:paymentPage===paymentPages?'not-allowed':'pointer', background:paymentPage===paymentPages?'#f5f5f5':'white'}}>»</button>
                  <span style={{color:'#666', fontSize:'13px', marginLeft:'8px'}}>{((paymentPage-1)*paymentPageSize)+1}-{Math.min(paymentPage*paymentPageSize, paymentTotal)} / {paymentTotal} kayıt | Sayfa {paymentPage} / {paymentPages}</span>
                </div>
                )}
              </>
            )}

            {/* Özet Rapor */}
            {supplierSubTab === 'summary' && summaryData && (
              <>
                <div className="page-header">
                  <h2>Tedarikçi Özet Raporu</h2>
                  <div className="header-actions filter-row">
                    <select className="filter-select" value={summaryYear} onChange={(e) => setSummaryYear(parseInt(e.target.value))}>
                      {[2025, 2026, 2027, 2028, 2029, 2030].map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                    <select className="filter-select" value={summaryMonth} onChange={(e) => setSummaryMonth(e.target.value)}>
                      <option value="">Tüm Yıl</option>
                      {MONTH_NAMES.slice(1).map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
                    </select>
                    <button className="btn-excel" onClick={exportSummaryToExcel}>📥 Excel</button>
                  </div>
                </div>

                <div className="finance-summary-cards">
                  <div className="finance-card warning"><span className="card-label">Toplam Alınan</span><span className="card-value">{summaryData.summary.total_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                  <div className="finance-card income"><span className="card-label">Toplam Ödenen</span><span className="card-value">{summaryData.summary.total_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                  <div className={`finance-card ${summaryData.summary.total_balance > 0 ? 'expense' : 'income'}`}><span className="card-label">Toplam Bakiye</span><span className="card-value">{summaryData.summary.total_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</span></div>
                </div>

                <div className="table-container">
                <table>
                <thead>
                <tr>
                 <th>Tedarikçi</th>
                 <th>Devir</th>
                 <th>Dönem Alınan</th>
                 <th>Nakit/Havale</th>
                 <th>Kart</th>
                 <th>Çek</th>
                 <th>Dönem Ödenen</th>
                 <th>Kalan Bakiye</th>
                </tr>
                </thead>
                 <tbody>
                  {summaryData.suppliers.map(s => (
                   <tr key={s.supplier_id}>
                    <td><strong>{s.supplier_name}</strong></td>
                    <td>{s.opening_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className="text-warning">{s.period_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className="text-success">{(s.payment_cash || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className="text-success">{(s.payment_card || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className="text-success">{(s.payment_check || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className="text-success">{s.period_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</td>
                    <td className={s.closing_balance > 0 ? 'text-danger' : 'text-success'}>
                    <strong>{s.closing_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                      </td>
                      </tr>
                        ))}
                     </tbody>
                      <tfoot>
                    <tr className="summary-row">
                      <td><strong>TOPLAM</strong></td>
                      <td><strong>{summaryData.suppliers.reduce((sum, s) => sum + s.opening_balance, 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className="text-warning"><strong>{summaryData.summary.total_invoices.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className="text-success"><strong>{summaryData.suppliers.reduce((sum, s) => sum + (s.payment_cash || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className="text-success"><strong>{summaryData.suppliers.reduce((sum, s) => sum + (s.payment_card || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className="text-success"><strong>{summaryData.suppliers.reduce((sum, s) => sum + (s.payment_check || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className="text-success"><strong>{summaryData.summary.total_payments.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong></td>
                      <td className={summaryData.summary.total_balance > 0 ? 'text-danger' : 'text-success'}>
                      <strong>{summaryData.summary.total_balance.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺</strong>
                      </td>
                      </tr>
                      </tfoot>
                    </table>
                </div>
              </>
            )}
          </>
        )}
      </div>

      {/* ==================== MODALLAR ==================== */}

      {/* GELİR MODAL */}
<Modal isOpen={isIncomeModalOpen} onClose={() => setIsIncomeModalOpen(false)} title={editingTransaction ? 'Gelir Düzenle' : 'Gelir Ekle'} size="medium">
  <form onSubmit={handleIncomeSubmit}>
    <div className="form-row">
      <div className="form-group">
        <label>Tarih *</label>
        <input type="date" value={incomeFormData.transaction_date} onChange={(e) => setIncomeFormData({...incomeFormData, transaction_date: e.target.value})} required />
      </div>
      <div className="form-group">
        <label>Tutar (₺) *</label>
        <input type="number" step="0.01" value={incomeFormData.amount} onChange={(e) => setIncomeFormData({...incomeFormData, amount: e.target.value})} required />
      </div>
    </div>
    
    <div className="form-group">
      <label>Ödemesi Gelen (Kişi/Firma) *</label>
      <input type="text" value={incomeFormData.payer_name} onChange={(e) => setIncomeFormData({...incomeFormData, payer_name: e.target.value})} placeholder="Müşteri veya firma adı" required />
    </div>
    
    <div className="form-group">
      <label>Ödeme Yöntemi *</label>
      <select value={incomeFormData.payment_method} onChange={(e) => setIncomeFormData({...incomeFormData, payment_method: e.target.value})} required>
        {PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
      </select>
    </div>
    
    <div className="form-group">
      <label>Teslim Alan (Hesap/Kasa)</label>
      <div className="input-with-checkbox">
        <select 
          value={incomeFormData.receiver_account_id} 
          onChange={(e) => setIncomeFormData({...incomeFormData, receiver_account_id: e.target.value})}
          disabled={incomeFormData.use_manual_receiver}
        >
          <option value="">Seçiniz</option>
          {incomeAccounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        <label className="checkbox-label">
          <input 
            type="checkbox" 
            checked={incomeFormData.use_manual_receiver} 
            onChange={(e) => setIncomeFormData({...incomeFormData, use_manual_receiver: e.target.checked, receiver_account_id: ''})} 
          />
          <span>Manuel giriş</span>
        </label>
      </div>
    </div>
    
    {incomeFormData.use_manual_receiver && (
      <div className="form-group">
        <label>Manuel Hesap/Kasa Adı</label>
        <input 
          type="text" 
          value={incomeFormData.receiver_manual} 
          onChange={(e) => setIncomeFormData({...incomeFormData, receiver_manual: e.target.value})} 
          placeholder="Örn: Çekmece, Cüzdan, Elden" 
        />
      </div>
    )}
    
    <div className="form-group">
      <label>Notlar</label>
      <textarea value={incomeFormData.notes} onChange={(e) => setIncomeFormData({...incomeFormData, notes: e.target.value})} rows="2" />
    </div>
    
    <div className="form-actions">
      <button type="button" className="btn btn-secondary" onClick={() => setIsIncomeModalOpen(false)}>İptal</button>
      <button type="submit" className="btn btn-success">Kaydet</button>
    </div>
  </form>
</Modal>

      {/* GİDER MODAL */}
<Modal isOpen={isExpenseModalOpen} onClose={() => setIsExpenseModalOpen(false)} title={editingTransaction ? 'Gider Düzenle' : 'Gider Ekle'} size="medium">
  <form onSubmit={handleExpenseSubmit}>
    <div className="form-row">
      <div className="form-group">
        <label>Tarih *</label>
        <input type="date" value={expenseFormData.transaction_date} onChange={(e) => setExpenseFormData({...expenseFormData, transaction_date: e.target.value})} required />
      </div>
      <div className="form-group">
        <label>Tutar (₺) *</label>
        <input type="number" step="0.01" value={expenseFormData.amount} onChange={(e) => setExpenseFormData({...expenseFormData, amount: e.target.value})} required />
      </div>
    </div>
    
    <div className="form-group">
      <label>Ödemesi Yapılan (Kişi/Firma) *</label>
      <input type="text" value={expenseFormData.payee_name} onChange={(e) => setExpenseFormData({...expenseFormData, payee_name: e.target.value})} placeholder="Ödeme yapılan kişi veya firma" required />
    </div>
    
    <div className="form-row">
      <div className="form-group">
        <label>Kategori</label>
        <select value={expenseFormData.category_id} onChange={(e) => setExpenseFormData({...expenseFormData, category_id: e.target.value})}>
          <option value="">Seçiniz</option>
          {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label>Ödeme Yöntemi *</label>
        <select value={expenseFormData.payment_method} onChange={(e) => setExpenseFormData({...expenseFormData, payment_method: e.target.value, payer_card_id: '', payer_account_id: ''})} required>
          {PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
      </div>
    </div>
    
    <div className="form-group">
      <label>Ödeyen {expenseFormData.payment_method === 'kredi_karti' ? '(Kart)' : '(Hesap/Kasa)'}</label>
      <div className="input-with-checkbox">
        {expenseFormData.payment_method === 'kredi_karti' ? (
          <select 
            value={expenseFormData.payer_card_id} 
            onChange={(e) => setExpenseFormData({...expenseFormData, payer_card_id: e.target.value})}
            disabled={expenseFormData.use_manual_payer}
          >
            <option value="">Seçiniz</option>
            {expenseCards.map(c => <option key={c.id} value={c.id}>{c.name} {c.notes ? `(${c.notes})` : ''}</option>)}
          </select>
        ) : (
          <select 
            value={expenseFormData.payer_account_id} 
            onChange={(e) => setExpenseFormData({...expenseFormData, payer_account_id: e.target.value})}
            disabled={expenseFormData.use_manual_payer}
          >
            <option value="">Seçiniz</option>
            {expenseAccounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        )}
        <label className="checkbox-label">
          <input 
            type="checkbox" 
            checked={expenseFormData.use_manual_payer} 
            onChange={(e) => setExpenseFormData({...expenseFormData, use_manual_payer: e.target.checked, payer_account_id: '', payer_card_id: ''})} 
          />
          <span>Manuel giriş</span>
        </label>
      </div>
    </div>
    
    {expenseFormData.use_manual_payer && (
      <div className="form-group">
        <label>Manuel Hesap/Kasa Adı</label>
        <input 
          type="text" 
          value={expenseFormData.payer_manual} 
          onChange={(e) => setExpenseFormData({...expenseFormData, payer_manual: e.target.value})} 
          placeholder="Örn: Çekmece, Cüzdan, Elden" 
        />
      </div>
    )}
    
    <div className="form-group">
      <label>Notlar</label>
      <textarea value={expenseFormData.notes} onChange={(e) => setExpenseFormData({...expenseFormData, notes: e.target.value})} rows="2" />
    </div>
    
    <div className="form-actions">
      <button type="button" className="btn btn-secondary" onClick={() => setIsExpenseModalOpen(false)}>İptal</button>
      <button type="submit" className="btn btn-danger">Kaydet</button>
    </div>
  </form>
</Modal>

      {/* GELİR HESABI MODAL */}
      <Modal isOpen={isIncomeAccountModalOpen} onClose={() => setIsIncomeAccountModalOpen(false)} title="Gelir Hesabı Ekle" size="small">
        <form onSubmit={handleAddIncomeAccount}>
          <div className="form-group"><label>Hesap/Kasa Adı *</label><input type="text" value={incomeAccountForm.name} onChange={(e) => setIncomeAccountForm({...incomeAccountForm, name: e.target.value})} required /></div>
          <div className="form-group"><label>Tip</label>
            <select value={incomeAccountForm.account_type} onChange={(e) => setIncomeAccountForm({...incomeAccountForm, account_type: e.target.value})}>
              <option value="kasa">Kasa</option><option value="banka">Banka</option>
            </select>
          </div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsIncomeAccountModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Ekle</button></div>
        </form>
      </Modal>

      {/* GİDER HESABI MODAL */}
      <Modal isOpen={isExpenseAccountModalOpen} onClose={() => setIsExpenseAccountModalOpen(false)} title="Gider Hesabı Ekle" size="small">
        <form onSubmit={handleAddExpenseAccount}>
          <div className="form-group"><label>Hesap/Kasa Adı *</label><input type="text" value={expenseAccountForm.name} onChange={(e) => setExpenseAccountForm({...expenseAccountForm, name: e.target.value})} required /></div>
          <div className="form-group"><label>Tip</label>
            <select value={expenseAccountForm.account_type} onChange={(e) => setExpenseAccountForm({...expenseAccountForm, account_type: e.target.value})}>
              <option value="kasa">Kasa</option><option value="banka">Banka</option>
            </select>
          </div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsExpenseAccountModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Ekle</button></div>
        </form>
      </Modal>

      {/* GİDER KARTI MODAL */}
      <Modal isOpen={isExpenseCardModalOpen} onClose={() => setIsExpenseCardModalOpen(false)} title="Gider Kartı Ekle" size="small">
        <form onSubmit={handleAddExpenseCard}>
          <div className="form-group"><label>Kart Adı *</label><input type="text" value={expenseCardForm.name} onChange={(e) => setExpenseCardForm({...expenseCardForm, name: e.target.value})} placeholder="Örn: Garanti Bonus" required /></div>
          <div className="form-group"><label>Banka</label><input type="text" value={expenseCardForm.bank_name} onChange={(e) => setExpenseCardForm({...expenseCardForm, bank_name: e.target.value})} placeholder="Örn: Garanti Bankası" /></div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsExpenseCardModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Ekle</button></div>
        </form>
      </Modal>

      {/* KATEGORİ MODAL */}
      <Modal isOpen={isCategoryModalOpen} onClose={() => setIsCategoryModalOpen(false)} title="Yeni Kategori Ekle" size="small">
        <form onSubmit={handleAddCategory}>
          <div className="form-group"><label>Kategori Adı *</label><input type="text" value={categoryForm.name} onChange={(e) => setCategoryForm({...categoryForm, name: e.target.value})} required /></div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsCategoryModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Ekle</button></div>
        </form>
      </Modal>

      {/* TEDARİKÇİ MODAL */}
      <Modal isOpen={isSupplierModalOpen} onClose={() => setIsSupplierModalOpen(false)} title={editingSupplier ? 'Tedarikçi Düzenle' : 'Yeni Tedarikçi'} size="medium">
        <form onSubmit={handleSupplierSubmit}>
          <div className="form-row">
            <div className="form-group"><label>Firma Adı *</label><input type="text" value={supplierForm.name} onChange={(e) => setSupplierForm({...supplierForm, name: e.target.value})} required /></div>
            <div className="form-group"><label>İlgili Kişi</label><input type="text" value={supplierForm.contact_person} onChange={(e) => setSupplierForm({...supplierForm, contact_person: e.target.value})} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Telefon</label><input type="text" value={supplierForm.phone} onChange={(e) => setSupplierForm({...supplierForm, phone: e.target.value})} /></div>
            <div className="form-group"><label>Email</label><input type="email" value={supplierForm.email} onChange={(e) => setSupplierForm({...supplierForm, email: e.target.value})} /></div>
          </div>
          <div className="form-group"><label>Adres</label><textarea value={supplierForm.address} onChange={(e) => setSupplierForm({...supplierForm, address: e.target.value})} rows="2" /></div>
          <div className="form-group"><label>Notlar</label><textarea value={supplierForm.notes} onChange={(e) => setSupplierForm({...supplierForm, notes: e.target.value})} rows="2" /></div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsSupplierModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
        </form>
      </Modal>

      {/* FATURA MODAL */}
      <Modal isOpen={isInvoiceModalOpen} onClose={() => setIsInvoiceModalOpen(false)} title={editingInvoice ? 'Fatura Düzenle' : 'Fatura / Malzeme Ekle'} size="medium">
        <form onSubmit={handleSubmitInvoice}>
          <div className="form-row">
            <div className="form-group"><label>Fatura Tarihi *</label><input type="date" value={invoiceForm.invoice_date} onChange={(e) => setInvoiceForm({...invoiceForm, invoice_date: e.target.value})} required /></div>
            <div className="form-group"><label>Fatura No</label><input type="text" value={invoiceForm.invoice_no} onChange={(e) => setInvoiceForm({...invoiceForm, invoice_no: e.target.value})} /></div>
          </div>
          <div className="form-group"><label>Tutar (₺) *</label><input type="number" step="0.01" value={invoiceForm.amount} onChange={(e) => setInvoiceForm({...invoiceForm, amount: e.target.value})} required /></div>
          <div className="form-group"><label>Açıklama</label><input type="text" value={invoiceForm.description} onChange={(e) => setInvoiceForm({...invoiceForm, description: e.target.value})} /></div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsInvoiceModalOpen(false)}>İptal</button><button type="submit" className="btn btn-warning btn-wide">{editingInvoice ? 'Güncelle' : 'Fatura Kaydet'}</button></div>
        </form>
      </Modal>

      {/* ÖDEME MODAL */}
      <Modal isOpen={isPaymentModalOpen} onClose={() => setIsPaymentModalOpen(false)} title={editingPayment ? 'Ödeme Düzenle' : 'Ödeme Ekle'} size="medium">
        <form onSubmit={handleSubmitPayment}>
          <div className="form-row">
            <div className="form-group"><label>Ödeme Tarihi *</label><input type="date" value={paymentForm.payment_date} onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})} required /></div>
            <div className="form-group"><label>Ödeme Yöntemi *</label>
              <select value={paymentForm.payment_method} onChange={(e) => setPaymentForm({...paymentForm, payment_method: e.target.value})} required>
                {SUPPLIER_PAYMENT_METHODS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
              </select>
            </div>
          </div>
          <div className="form-group"><label>Tutar (₺) *</label><input type="number" step="0.01" value={paymentForm.amount} onChange={(e) => setPaymentForm({...paymentForm, amount: e.target.value})} required /></div>
          <div className="form-group"><label>Referans No (Dekont/Çek No)</label><input type="text" value={paymentForm.reference_no} onChange={(e) => setPaymentForm({...paymentForm, reference_no: e.target.value})} /></div>
          <div className="form-group"><label>Açıklama</label><input type="text" value={paymentForm.description} onChange={(e) => setPaymentForm({...paymentForm, description: e.target.value})} /></div>
          <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsPaymentModalOpen(false)}>İptal</button><button type="submit" className="btn btn-success btn-wide">{editingPayment ? 'Güncelle' : 'Ödeme Kaydet'}</button></div>
        </form>
      </Modal>

{/* TRANSFER MODAL */}
<Modal isOpen={isTransferModalOpen} onClose={() => setIsTransferModalOpen(false)} title={editingTransfer ? 'Transfer Düzenle' : 'Ciro / Transfer Ekle'} size="large">
  <form onSubmit={handleTransferSubmit}>
    <div className="form-row">
      <div className="form-group">
        <label>Tarih *</label>
        <input type="date" value={transferFormData.transfer_date} onChange={(e) => setTransferFormData({...transferFormData, transfer_date: e.target.value})} required />
      </div>
      <div className="form-group">
        <label>Transfer Tipi *</label>
        <select value={transferFormData.transfer_type} onChange={(e) => setTransferFormData({...transferFormData, transfer_type: e.target.value})} required>
          {TRANSFER_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label>Tutar (₺) *</label>
        <input type="number" step="0.01" value={transferFormData.amount} onChange={(e) => setTransferFormData({...transferFormData, amount: e.target.value})} required />
      </div>
    </div>

    <div className="form-section">
      <h4>📤 Kaynak (Nereden)</h4>
      <div className="form-row">
        <div className="form-group">
          <label>Kaynak Tipi *</label>
          <select value={transferFormData.source_type} onChange={(e) => setTransferFormData({...transferFormData, source_type: e.target.value, source_name: '', source_supplier_id: '', source_account_id: ''})}>
            {SOURCE_TYPES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
        <div className="form-group">
          {transferFormData.source_type === 'customer' && (
            <><label>Müşteri Adı *</label><input type="text" value={transferFormData.source_name} onChange={(e) => setTransferFormData({...transferFormData, source_name: e.target.value})} placeholder="Müşteri / Firma adı" required /></>
          )}
          {transferFormData.source_type === 'supplier' && (
            <><label>Tedarikçi *</label><select value={transferFormData.source_supplier_id} onChange={(e) => setTransferFormData({...transferFormData, source_supplier_id: e.target.value})} required><option value="">Seçiniz</option>{suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</select></>
          )}
          {transferFormData.source_type === 'account' && (
            <><label>Hesap/Kasa *</label><select value={transferFormData.source_account_id} onChange={(e) => setTransferFormData({...transferFormData, source_account_id: e.target.value})} required><option value="">Seçiniz</option>{incomeAccounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}</select></>
          )}
        </div>
      </div>
    </div>

    <div className="form-section">
      <h4>📥 Hedef (Nereye)</h4>
      <div className="form-row">
        <div className="form-group">
          <label>Hedef Tipi *</label>
          <select value={transferFormData.target_type} onChange={(e) => setTransferFormData({...transferFormData, target_type: e.target.value, target_name: '', target_supplier_id: '', target_account_id: ''})}>
            {TARGET_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
        <div className="form-group">
          {transferFormData.target_type === 'supplier' && (
            <><label>Tedarikçi *</label><select value={transferFormData.target_supplier_id} onChange={(e) => setTransferFormData({...transferFormData, target_supplier_id: e.target.value})} required><option value="">Seçiniz</option>{suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</select></>
          )}
          {transferFormData.target_type === 'account' && (
            <><label>Hesap/Kasa *</label><select value={transferFormData.target_account_id} onChange={(e) => setTransferFormData({...transferFormData, target_account_id: e.target.value})} required><option value="">Seçiniz</option>{expenseAccounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}</select></>
          )}
          {transferFormData.target_type === 'other' && (
            <><label>Hedef Adı *</label><input type="text" value={transferFormData.target_name} onChange={(e) => setTransferFormData({...transferFormData, target_name: e.target.value})} placeholder="Hedef açıklama" required /></>
          )}
        </div>
      </div>
    </div>

    {transferFormData.transfer_type === 'cek' && (
      <div className="form-section">
        <h4>📝 Çek Bilgileri</h4>
        <div className="form-row">
          <div className="form-group"><label>Çek No</label><input type="text" value={transferFormData.check_no} onChange={(e) => setTransferFormData({...transferFormData, check_no: e.target.value})} /></div>
          <div className="form-group"><label>Banka</label><input type="text" value={transferFormData.check_bank} onChange={(e) => setTransferFormData({...transferFormData, check_bank: e.target.value})} /></div>
          <div className="form-group"><label>Vade Tarihi</label><input type="date" value={transferFormData.check_due_date} onChange={(e) => setTransferFormData({...transferFormData, check_due_date: e.target.value})} /></div>
        </div>
      </div>
    )}

    <div className="form-group"><label>Notlar</label><textarea value={transferFormData.notes} onChange={(e) => setTransferFormData({...transferFormData, notes: e.target.value})} rows="2" /></div>
    <div className="form-actions"><button type="button" className="btn btn-secondary" onClick={() => setIsTransferModalOpen(false)}>İptal</button><button type="submit" className="btn btn-primary">Kaydet</button></div>
  </form>
</Modal>

  {/* KART GİDERİ MODAL */}
  <Modal isOpen={isCardExpenseModalOpen} onClose={() => setIsCardExpenseModalOpen(false)} title={editingCardExpense ? 'Kart Gideri Düzenle' : 'Kart Gideri Ekle'} size="medium">
    <form onSubmit={handleCardExpenseSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label>Tarih *</label>
          <input type="date" value={cardExpFormData.transaction_date} onChange={(e) => setCardExpFormData({...cardExpFormData, transaction_date: e.target.value})} required />
        </div>
        <div className="form-group">
          <label>Tutar (₺) *</label>
          <input type="number" step="0.01" value={cardExpFormData.amount} onChange={(e) => setCardExpFormData({...cardExpFormData, amount: e.target.value})} required />
        </div>
      </div>
      
      <div className="form-group">
        <label>Kullanılan Kart *</label>
        <select value={cardExpFormData.card_id} onChange={(e) => setCardExpFormData({...cardExpFormData, card_id: e.target.value})} required>
          <option value="">Kart Seçiniz</option>
          {expenseCards.map(c => <option key={c.id} value={c.id}>{c.name} {c.notes ? `(${c.notes})` : ''}</option>)}
        </select>
      </div>
      
      <div className="form-group">
        <label>Ödeme Yapılan Yer *</label>
        <input type="text" value={cardExpFormData.payer_receiver} onChange={(e) => setCardExpFormData({...cardExpFormData, payer_receiver: e.target.value})} placeholder="Mağaza, firma veya kişi adı" required />
      </div>
      
      <div className="form-group" style={{padding:'15px', backgroundColor:'#f8f9fa', borderRadius:'8px', marginTop:'10px'}}>
      <label style={{fontWeight:'500', marginBottom:'10px', display:'block'}}>Ödeme Şekli</label>
      <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
        <button type="button" onClick={() => setCardExpFormData({...cardExpFormData, is_installment: false, installment_count: ''})}
          style={{padding:'8px 16px', borderRadius:'6px',
            border: !cardExpFormData.is_installment ? '2px solid #4caf50' : '1px solid #ddd',
            background: !cardExpFormData.is_installment ? '#4caf50' : 'white',
            color: !cardExpFormData.is_installment ? 'white' : '#333',
            cursor:'pointer', fontWeight:'500', fontSize:'13px'}}>
          Tek Çekim
        </button>
        {[2, 3, 4, 6, 9, 12].map(n => (
          <button key={n} type="button" onClick={() => setCardExpFormData({...cardExpFormData, is_installment: true, installment_count: n})}
            style={{padding:'8px 16px', borderRadius:'6px',
              border: cardExpFormData.is_installment && cardExpFormData.installment_count === n ? '2px solid #667eea' : '1px solid #ddd',
              background: cardExpFormData.is_installment && cardExpFormData.installment_count === n ? 'linear-gradient(135deg,#667eea,#764ba2)' : 'white',
              color: cardExpFormData.is_installment && cardExpFormData.installment_count === n ? 'white' : '#333',
              cursor:'pointer', fontWeight:'500', fontSize:'13px'}}>
            {n} Taksit
          </button>
        ))}
      </div>
      <div style={{display:'flex', alignItems:'center', gap:'8px', marginTop:'10px'}}>
        <span style={{fontSize:'13px', color:'#666'}}>veya</span>
        <input type="number" min="2" max="48"
          value={cardExpFormData.is_installment ? cardExpFormData.installment_count : ''}
          onChange={(e) => setCardExpFormData({...cardExpFormData, is_installment: true, installment_count: parseInt(e.target.value) || ''})}
          placeholder=""
          style={{width:'80px', padding:'8px', borderRadius:'6px', border:'1px solid #ddd', fontSize:'13px', textAlign:'center'}} />
        <span style={{fontSize:'13px', color:'#666'}}>taksit</span>
      </div>
    </div>
      
      <div className="form-group" style={{marginTop:'15px'}}>
        <label>Notlar</label>
        <textarea value={cardExpFormData.notes} onChange={(e) => setCardExpFormData({...cardExpFormData, notes: e.target.value})} rows="2" />
      </div>
      
      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={() => setIsCardExpenseModalOpen(false)}>İptal</button>
        <button type="submit" className="btn btn-primary">Kaydet</button>
      </div>
    </form>
  </Modal>

      {/* ONAY MODAL */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        loading={confirmModal.loading}
      />
    </div>
  );
}

export default Finance;